<template>
  <div class="huddle-page">
    <!-- Page Header -->
    <div class="huddle-header">
      <div class="header-left">
        <h1 class="page-title">Today's Huddle</h1>
        <div class="header-date-picker">
          <DatePicker lang="en" input-class="form-control" v-model="huddleDate" format="MM-DD-YYYY" @change="loadData">
            <i class="glyphicon glyphicon-th" slot="calendar-icon" />
          </DatePicker>
        </div>
      </div>
      <div class="header-actions">
        <b-button variant="primary" size="sm" class="action-btn" @click="viewAdvancedTxPlanned">
          <i class="glyphicon glyphicon-list" />
          <span>View Tx Presented vs Accepted</span>
        </b-button>
        <b-button variant="primary" size="sm" class="action-btn" @click="viewProductionTrends">
          <i class="glyphicon glyphicon-stats" />
          <span>Production Trends</span>
        </b-button>
        <b-button variant="outline-secondary" size="sm" class="action-btn explainer-btn"
          @click="openMetricsExplainer()">
          <i class="la la-info-circle" />
          <span>What do these numbers mean?</span>
        </b-button>
        <div class="settings-icon" @click="setGoals" title="Set Goals">
          <i class="la la-cog" />
        </div>
      </div>
    </div>

    <HuddleSkeleton v-if="busy" />

    <div class="huddle-content" v-if="allSettings" v-show="!busy">
      <ErrorDisplay />

            <b-row class="mb-3" v-if="this.huddleGoals">
              <b-col xs="12" sm="6" md="6" lg="3" class="chart-col">
                <b-card class="border-0 shadow-sm overdue-recall-card-wrap">
                  <h6 class="fw-semi-bold">Net Production Month-to-Date</h6>
                  <div class="chart-container">
                    <ChartJSBarChart v-if="getMTDNetProductionChartData" :chartData="getMTDNetProductionChartData"
                      :dateRange="dateRange" :timeRange="timeRange" :options="barChartOptions" />
                    <div v-else class="empty-chart">
                      No data available for Net Production.
                    </div>
                  </div>
                </b-card>
              </b-col>
              <b-col xs="12" sm="6" md="6" lg="3" class="chart-col">
                <b-card class="border-0 shadow-sm overdue-recall-card-wrap">
                  <h6 class="fw-semi-bold">Collections Month-to-Date</h6>
                  <div class="chart-container">
                    <ChartJSBarChart v-if="getMTDCollectionChartData" :chartData="getMTDCollectionChartData"
                      :dateRange="dateRange" :timeRange="timeRange" :options="barChartOptions" />
                    <div v-else class="empty-chart">
                      No data available for Collections.
                    </div>
                  </div>
                </b-card>
              </b-col>
              <b-col xs="12" sm="6" md="6" lg="3" class="chart-col">
                <b-card class="border-0 shadow-sm overdue-recall-card-wrap">
                  <h6 class="fw-semi-bold">New Patients Month-to-date</h6>
                  <div class="chart-container">
                    <ChartJSBarChart v-if="getMTDNewPatientsChartData" :chartData="getMTDNewPatientsChartData"
                      :dateRange="dateRange" :timeRange="timeRange" :options="barChartOptions" />
                    <div v-else class="empty-chart">
                      No data available for New Patients.
                    </div>
                  </div>
                </b-card>
              </b-col>
              <b-col xs="12" sm="6" md="6" lg="3" class="chart-col">
                <b-card class="border-0 shadow-sm overdue-recall-card-wrap">
                  <h6 class="fw-semi-bold">Outstanding Claims</h6>
                  <div class="chart-container">
                    <PieChart :chartdata="getOutstandingClaimsData" :options="chartOptions" :styles="chartStyles"
                      :key="1" />
                  </div>
                </b-card>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <Widget class="mb-3 shadow-sm"
                  title="<h5 class='fw-bold'>Today's Completed Production<span class='fw-bold'> (Net): <span class='h2 fw-semi-bold'></span></span></h5>"
                  customHeader>
                  <b-row>
                    <b-col class="px-xl-3" md="12" lg="6" sm="12" xs="12" xl="6">
                      <!-- start of Production (net) panel -->
                      <div class="production-panel">
                        <div class="production-header">
                          <h2 class="production-amount">
                            {{netProductionToday | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
                            <MetricInfo :entry="metricGlossary['completed-production-net']" placement="right"
                              @open-breakdown="openMetricsExplainer" />
                            <span v-if="totalPracticeProductionPerHour !== null" class="production-per-hour">
                              ({{totalPracticeProductionPerHour | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}/hr)
                              <MetricInfo :entry="metricGlossary['production-per-hour']" placement="right"
                                @open-breakdown="openMetricsExplainer" />
                            </span>
                          </h2>
                        </div>
                      <div v-if="this.grossProductionTodayByProvider && this.scheduledProductionTodayByProvider && providersOnScheduleToday && providersOnScheduleToday.length > 0">
                        <!--
                          <div class="clearfix fs-mini mt">
                            <span class="pull-right m-0 fw-semi-bold">On Schedule: <span class="fw-semi-bold">{{scheduledProductionToday | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></span>
                            <span class="fs-mini">Goal</span>
                          </div>
                          -->
                        <!--<b-progress max="100" variant="success" class="bg-gray-lighter progress-xs mb-4" value="20"  />-->
                        <b-progress :max="scheduledProductionToday" :value="netProductionToday" variant="success"
                          class="bg-gray-lighter progress-xs mb-4" />

                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                              <tr>
                                <th>
                                  <h6 class="fw-semi-bold mt-1">Provider</h6>
                                </th>
                                <th>
                                  <h6 class="fw-semi-bold mt-1">Completed Production (Net)
                                    <MetricInfo :entry="metricGlossary['completed-production-net']" placement="bottom"
                                      @open-breakdown="openMetricsExplainer" />
                                  </h6>
                                </th>
                                <th>
                                  <h6 class="fw-semi-bold mt-1">$/HR
                                    <MetricInfo :entry="metricGlossary['production-per-hour']" placement="bottom"
                                      @open-breakdown="openMetricsExplainer" />
                                  </h6>
                                </th>
                                <th>
                                  <h6 class="fw-semi-bold mt-1">On Schedule (Net)
                                    <MetricInfo :entry="metricGlossary['on-schedule-net']" placement="bottom"
                                      @open-breakdown="openMetricsExplainer" />
                                  </h6>
                                </th>
                                <th>
                                  <h6 class="fw-semi-bold mt-1">Sched $/HR
                                    <MetricInfo :entry="metricGlossary['scheduled-per-hour']" placement="bottomleft"
                                      @open-breakdown="openMetricsExplainer" />
                                  </h6>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(provNum, index) in providersOnScheduleToday" :key="index">
                                <td>
                                  <p>{{getProvNameFromNum(provNum)}}</p>
                                  <p>
                                    <small>
                                      <span class="text-muted">({{getAbbrFromProvNum(provNum)}})</span>
                                    </small>
                                  </p>
                                </td>
                                <td>
                                  <p class="mb-0 h4">{{getNetProductionToday(provNum) |
                                    money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
                                    <small><span class="text-muted fw-normal">Today</span></small>
                                    <!-- <a href="#" tabindex="0" :id="`today_net_production-${provNum}`" v-if="getNetProductionToday(provNum) > 0"><i class="small fa fa-list-alt"></i></a>   -->
                                    <a href="#" @click="showModal($event, `today_net_production-${provNum}`, provNum)"
                                      tabindex="0" v-if="getNetProductionToday(provNum) > 0" style="color: #798892; "><i
                                        class="small fa fa-list-alt"></i></a>
                                  </p>


                                  <b-progress :max="getScheduledProductionToday(provNum)"
                                    :value="getNetProductionToday(provNum)" variant="warning"
                                    class="bg-gray-lighter progress-sm mb-xs mt-1" height="1.1rem" />
                                  <p>
                                    <small>
                                      <span class="text-muted">Month-to-date:</span>
                                      <span class="fw-semi-bold">&nbsp; {{ getNetProductionMTD(provNum) |
                                        money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue) }}</span>
                                    </small>
                                    <MetricInfo :entry="metricGlossary['net-production-mtd']" placement="right"
                                      @open-breakdown="openMetricsExplainer" />&nbsp;
                                    <a href="#" @click="showModal($event, `mtd_net_production-${provNum}`, provNum)"
                                      tabindex="0" v-if="getNetProductionMTD(provNum) > 0" style="color: #798892; "><i
                                        class="small fa fa-list-alt"></i></a>

                                  </p>

                                  <b-progress v-if="getMonthlyProductionGoal(provNum) > 0"
                                    :max="getMonthlyProductionGoal(provNum)"
                                    :value="getNetProductionMTD(provNum)"
                                    variant="success"
                                    class="bg-gray-lighter progress-xs mb-xs"
                                    :title="'Month-to-date vs monthly goal: ' + $options.filters.money(getMonthlyProductionGoal(provNum), allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)" />
                                  <p class="mb-0 goal-pct" v-if="getMonthlyProductionGoal(provNum) > 0">
                                    {{ goalPercent(getNetProductionMTD(provNum), getMonthlyProductionGoal(provNum)) }}% of goal
                                    {{ getMonthlyProductionGoal(provNum) | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue) }}
                                    <MetricInfo :entry="metricGlossary['provider-goal-bar']" placement="right"
                                      @open-breakdown="openMetricsExplainer" />
                                  </p>

                                </td>
                                <td>
                                  <p class="h4 mb-0" v-if="getProductionPerHourToday(provNum) !== null">
                                    {{getProductionPerHourToday(provNum) | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
                                  </p>
                                  <p class="h4 text-muted mb-0" v-else>N/A</p>
                                  <p v-if="getClinicalHoursToday(provNum) > 0">
                                    <small>
                                      <span class="text-muted">({{getClinicalHoursToday(provNum).toFixed(2)}} hrs)</span>
                                    </small>
                                  </p>
                                </td>
                                <td>
                                  <p class="h4">{{getScheduledProductionToday(provNum) |
                                    money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</p>
                                  <p>
                                    <small>
                                      <span class="text-muted">This month:</span>
                                      <span class="fw-semi-bold">&nbsp; {{getScheduledProductionThisMonth(provNum) |
                                        money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                    </small>
                                    <MetricInfo :entry="metricGlossary['scheduled-this-month']" placement="left"
                                      @open-breakdown="openMetricsExplainer" />
                                  </p>

                                  <b-progress v-if="getMonthlyProductionGoal(provNum) > 0"
                                    :max="getMonthlyProductionGoal(provNum)"
                                    :value="getScheduledProductionThisMonth(provNum)"
                                    variant="success"
                                    class="bg-gray-lighter progress-xs mb-xs"
                                    :title="'Scheduled this month vs monthly goal: ' + $options.filters.money(getMonthlyProductionGoal(provNum), allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)" />
                                  <p class="mb-0 goal-pct" v-if="getMonthlyProductionGoal(provNum) > 0">
                                    {{ goalPercent(getScheduledProductionThisMonth(provNum), getMonthlyProductionGoal(provNum)) }}% of goal
                                    {{ getMonthlyProductionGoal(provNum) | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue) }}
                                  </p>
                                </td>
                                <td>
                                  <p class="h4 mb-0" v-if="getScheduledProductionPerHourToday(provNum) !== null">
                                    {{getScheduledProductionPerHourToday(provNum) | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
                                  </p>
                                  <p class="h4 text-muted mb-0" v-else>N/A</p>
                                  <p v-if="getClinicalHoursToday(provNum) > 0">
                                    <small>
                                      <span class="text-muted">({{getClinicalHoursToday(provNum).toFixed(2)}} hrs)</span>
                                    </small>
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </table>

                        </div>

                      </div>
                      <!-- Empty state when no providers on schedule -->
                      <div v-else class="production-empty-state">
                        <div class="empty-state-icon">
                          <i class="fa fa-calendar-check-o"></i>
                        </div>
                        <h4 class="empty-state-title">No Providers Scheduled</h4>
                        <p class="empty-state-text">There are no providers scheduled for today. Production data will appear once appointments are scheduled.</p>
                      </div>
                      </div>

                    </b-col>
                    <b-col class="px-xl-3" md="12" lg="6" sm="12" xs="12" xl="6">
                      <!-- start of Production vs. Collection panel -->
                      <div>
                        <Widget class="mb-0 prod-vs-collection-widget"
                          title="<h5 class='fw-bold'>Production & Collection</h5>" customHeader>
                          <!-- Production vs Collection Chart -->
                          <div class="chart-container">
                            <ChartJSBarChart v-if="getProductionVsCollectionData"
                              :chartData="getProductionVsCollectionData" :dateRange="'Production & Collection'"
                              :timeRange="'Current Month'" />
                            <div v-else class="empty-chart">
                              No data available for Production & Collection.
                            </div>
                          </div>
                          <div class="table-responsive ml-2 mt-5">
                            <table class="table prod-vs-collect" id="prod-vs-collect">
                              <tbody>
                                <tr class="border-bottom: 1px">
                                  <td class="legend-col">
                                    <span class="glyphicon glyphicon-stop mr-2 mb-1" style="color:#a7beff;"></span>
                                  </td>
                                  <td class="title-col">
                                    <h6 class="fw-semi-bold h6 mt-1">Total On Schedule (Net) Today:
                                      <MetricInfo :entry="metricGlossary['on-schedule-net']" placement="right"
                                        @open-breakdown="openMetricsExplainer" />
                                    </h6>
                                    <!--<p><a href="#" @click="viewHuddleDetails($event,'on-schedule')">View Details</a></p>-->
                                    <b-button variant="primary" class="btn-xs"
                                      @click="viewHuddleDetails($event,'on-schedule')">
                                      <span class="fw-semi-bold">View Next 2 Weeks</span>
                                      <i class="fa fa-external-link mr-s ml-xs mb-xs fw-semi-bold" />
                                    </b-button>
                                  </td>
                                  <td>
                                    <h5 class="fw-semi-bold">{{scheduledProductionToday |
                                      money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</h5>
                                    <p>
                                      <small>
                                        <span class="text-muted">Total this month:</span>
                                        <span class="fw-bold">&nbsp; {{scheduledProductionMTD |
                                          money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                      </small>
                                    </p>
                                    <b-progress v-if="monthlyScheduledGoal > 0"
                                      :max="monthlyScheduledGoal" :value="scheduledProductionMTD"
                                      variant="success" class="bg-gray-lighter progress-xs mb-xs"
                                      :title="'On Schedule this month vs monthly goal: ' + $options.filters.money(monthlyScheduledGoal, allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)" />
                                    <p class="mb-0 goal-pct" v-if="monthlyScheduledGoal > 0">
                                      {{ goalPercent(scheduledProductionMTD, monthlyScheduledGoal) }}% of goal
                                      {{ monthlyScheduledGoal | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue) }}
                                      <MetricInfo :entry="metricGlossary['office-goal-bar']" placement="left"
                                        @open-breakdown="openMetricsExplainer" />
                                    </p>

                                    <!--
                                        <b-button id="paom" variant="primary" class="btn-xs">
                                          <span class="fw-semi-bold" >$7,434</span>
                                        </b-button>
                                        -->
                                  </td>
                                </tr>

                                <tr>
                                  <td><span class="glyphicon glyphicon-stop mr-2 mb-1" style="color:#ace5d1;"></span>
                                  </td>
                                  <td>
                                    <h6 class="fw-semi-bold mt-1">Completed Production (Net)
                                      <MetricInfo :entry="metricGlossary['completed-production-net']" placement="right"
                                        @open-breakdown="openMetricsExplainer" />
                                    </h6>
                                  </td>
                                  <td>
                                    <h5 class="fw-semi-bold">{{netProductionToday |
                                      money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</h5>
                                    <p class="mt-0 mb-0">
                                      <small>
                                        <span class="text-muted">Total month-to-date:</span>
                                        <span class="fw-bold">&nbsp; {{netProductionMTD |
                                          money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                      </small>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span class="glyphicon glyphicon-stop mr-2 mb-1" style="color:#FFA45B;"></span>
                                  </td>
                                  <td>
                                    <h6 class="fw-semi-bold mt-1">Collection
                                      <MetricInfo :entry="metricGlossary['collection']" placement="right"
                                        @open-breakdown="openMetricsExplainer" />
                                    </h6>
                                  </td>
                                  <td>

                                    <!--
                                        <h5 class="fw-semi-bold">
                                          {{collectionToday | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}                                        
                                        </h5>
                                        &nbsp;<a href="#" :id="`today_collection_by_provider`" v-if="collectionTodayByProvider"><i class="small fa fa-list-alt"></i></a>
                                        -->

                                    <p class="mb-0 h4">{{collectionToday |
                                      money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
                                      <!-- <a href="#" tabindex="0" id="today_collection_by_provider" v-if="collectionTodayByProvider"><i class="small fa fa-list-alt"></i></a> -->

                                      <!--
                                              commenting out ability to view collection by provider for now (this was Paul's original request):
                                              for now we want to avoid reading from paysplit table since it's humongous and no one actually cares for 
                                              collection by provider.
                                          
                                          <a href="#" @click="showModal($event, `today_collection_by_provider`, null)" v-if="collectionTodayByProvider"><i class="small fa fa-list-alt"></i></a>  

                                          -->
                                    </p>
                                    <p class="mt-0 mb-0">
                                      <small>
                                        <span class="text-muted">Total month-to-date:</span>
                                        <span class="fw-bold">&nbsp; {{collectionMTD |
                                          money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>

                                        <!-- <a href="#" :id="`mtd_collection_by_provider`" v-if="collectionMTDByProvider"><i class="small fa fa-list-alt"></i></a> -->
                                        <!-- 

                                              commenting out ability to view collection by provider for now (this was Paul's original request):
                                              for now we want to avoid reading from paysplit table since it's humongous and no one actually cares for 
                                              collection by provider.

                                            <a href="#" @click="showModal($event, `mtd_collection_by_provider`, null)" v-if="collectionMTDByProvider"><i class="small fa fa-list-alt"></i></a>
                                            -->
                                      </small>
                                    </p>
                                  </td>
                                </tr>

                              </tbody>
                            </table>
                          </div>
                        </Widget>
                      </div>
                    </b-col>
                  </b-row>
                </Widget>
              </b-col>
            </b-row>


            <!--  end of HTML tempalte for bar graph -->

            <b-row class="middle-widgets-row">
              <!-- start of Net Tx plan -->
              <b-col lg="3" xs="12">
                <Widget class="mb-3 shadow-sm" title="<h5 class='fw-bold'>Net $ Tx Planned</h5>" customHeader>
                  <div>
                    <div class="table-responsive">
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th>
                              <h6 class="fw-semi-bold mt-1">Provider</h6>
                            </th>
                            <th>
                              <h6 class="fw-semi-bold mt-1">Today</h6>
                            </th>
                            <!-- <th><h6 class="fw-semi-bold mt-1">Previous Day</h6></th> -->
                            <th>
                              <h6 class="fw-semi-bold mt-1">Month-to-date</h6>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(provNum, index) in providersOnScheduleToday" :key="index">
                            <td>
                              <p class="h6">{{getProvNameFromNum(provNum)}}</p>
                            </td>
                            <td>
                              <p class="mb-0 h6">{{getNetTxPlannedTodayByProvider(provNum) |
                                money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
                                <!-- <a href="#" tabindex="0" :id="`today_tx_planned-${index}`" v-if="getNetTxPlannedTodayByProvider(provNum) > 0"><i class="small fa fa-list-alt"></i></a> -->
                                <a href="#" tabindex="0"
                                  @click="showModal($event,`today_tx_planned-${provNum}`, provNum)"
                                  v-if="getNetTxPlannedTodayByProvider(provNum) > 0"><i
                                    class="small fa fa-list-alt"></i></a>
                              </p>
                            </td>

                            <td>
                              <p class="mb-0 h6">{{getNetTxPlannedMTDByProvider(provNum) |
                                money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
                                <!-- <a href="#" tabindex="0" :id="`mtd_tx_planned-${index}`" v-if="getNetTxPlannedMTDByProvider(provNum) > 0"><i class="small fa fa-list-alt"></i></a>  -->
                                <a href="#" @click="showModal($event,`mtd_tx_planned-${provNum}`, provNum)"
                                  v-if="getNetTxPlannedMTDByProvider(provNum) > 0"><i
                                    class="small fa fa-list-alt"></i></a>
                              </p>

                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Widget>
              </b-col>
              <!-- end of Net Tx plan -->

              <!-- new hygiene re-appt -->
              <b-col lg="3" xs="12">
                <Widget class="mb-3 shadow-sm" title="<h5 class='fw-bold'>Hygiene Re-Appointment</h5>" customHeader>
                  <div>
                    <div class="table-responsive">
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th>
                              <h6 class="fw-semi-bold mt-1">Today</h6>
                            </th>
                            <th>
                              <h6 class="fw-semi-bold mt-1">This Month</h6>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Seen: <span class="h5 fw-semi-bold"><a href="#"
                                  @click="$bvModal.show('hygience-seen-today-details')">{{hygieneSeenToday.length}}</a></span>
                            </td>
                            <td>Seen: <span class="h5 fw-semi-bold"><a href="#"
                                  @click="$bvModal.show('hygience-seen-month-details')">{{hygieneSeenMTD.length}}</a></span>
                            </td>
                          </tr>
                          <tr>
                            <td>Re-appt: <span class="h5 fw-semi-bold"><a href="#"
                                  @click="$bvModal.show('hygience-reappt-today-details')">{{hygieneReapptToday.length}}</a>
                              </span> ({{hygieneReapptTodayPercent}}%)</td>
                            <td>Re-appt: <span class="h5 fw-semi-bold"><a href="#"
                                  @click="$bvModal.show('hygience-reappt-month-details')">{{hygieneReapptMTD.length}}</a></span>
                              ({{hygieneReapptMTDPercent}}%)</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Widget>
              </b-col>
              <!-- end of new hygiene re-appt -->

              <b-col lg="3" xs="12">
                <Widget class="mb-3 shadow-sm" title="<h5 class='fw-bold'>New Patients</h5>" customHeader>
                  <div class="stats-row mt-3">
                    <div class="stat-item">
                      <h6 class="fw-semi-bold mt-1">Today</h6>
                      <p class="h5 fw-semi-bold mt-2">
                        <a v-if="newPatientsToday" href="#"
                          @click="handleNewPatientsClick($event, 'today')">{{newPatientsToday.length}}</a>
                        <span v-else>0</span>
                      </p>
                    </div>
                    <div class="stat-item">
                      <h6 class="fw-semi-bold mt-1">This Month</h6>
                      <p class="h5 fw-semi-bold mt-2">
                        <a v-if="newPatientsMTD" href="#"
                          @click="handleNewPatientsClick($event, 'month-to-date')">{{newPatientsMTD.length}}</a>
                        <span v-else>0</span>
                      </p>
                    </div>
                  </div>
                </Widget>
              </b-col>


              <!-- start of patient balances widget-->
              <b-col lg="3" xs="12" v-if="onSchedulepatientBalances && onSchedulepatientBalances.length > 0">
                <Widget class="mb-3 shadow-sm" title="<h5 class='fw-bold'>Patient on Schedule Balances</h5>"
                  customHeader>
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>
                            <h6 class="fw-semi-bold mt-1">Operatory</h6>
                          </th>
                          <th>
                            <h6 class="fw-semi-bold mt-1">Patient</h6>
                          </th>
                          <th>
                            <h6 class="fw-semi-bold mt-1">Total Balance</h6>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(p, index) in onSchedulepatientBalances" :key="`ospb-${index}`">
                          <td>
                            <p class="h6">{{p.Operatory}}</p>
                          </td>
                          <td>
                            <p class="h6">{{p.Patient}}</p>
                          </td>
                          <td>
                            <p class="h6">{{p.TotalBalance | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Widget>
              </b-col>

            </b-row>

            <!-- Hygiene Opportunities Section -->
            <div class="opportunities-section">
              <h3 class="section-header">
                <i class="fa fa-lightbulb-o section-icon"></i>
                Hygiene Opportunities
              </h3>
              <div class="opportunities-grid">
                <div class="opportunity-card" @click="viewUnscheduledFamilyRecalls">
                  <div class="opportunity-icon">
                    <i class="fa fa-users"></i>
                  </div>
                  <div class="opportunity-content">
                    <span class="opportunity-title">Unscheduled Family Recalls</span>
                    <span class="opportunity-desc">View families due for recall</span>
                  </div>
                  <i class="fa fa-chevron-right opportunity-arrow"></i>
                </div>
                <div class="opportunity-card" @click="viewXrays">
                  <div class="opportunity-icon">
                    <i class="fa fa-file-image-o"></i>
                  </div>
                  <div class="opportunity-content">
                    <span class="opportunity-title">X-rays</span>
                    <span class="opportunity-desc">Patients due for X-rays</span>
                  </div>
                  <i class="fa fa-chevron-right opportunity-arrow"></i>
                </div>
                <div class="opportunity-card" @click="viewUnscheduledTx">
                  <div class="opportunity-icon">
                    <i class="fa fa-calendar-times-o"></i>
                  </div>
                  <div class="opportunity-content">
                    <span class="opportunity-title">Unscheduled Tx</span>
                    <span class="opportunity-desc">Treatment not yet scheduled</span>
                  </div>
                  <i class="fa fa-chevron-right opportunity-arrow"></i>
                </div>
                <div class="opportunity-card" @click="viewOrthoBenefits">
                  <div class="opportunity-icon">
                    <i class="fa fa-smile-o"></i>
                  </div>
                  <div class="opportunity-content">
                    <span class="opportunity-title">Ortho Benefits</span>
                    <span class="opportunity-desc">Patients with ortho coverage</span>
                  </div>
                  <i class="fa fa-chevron-right opportunity-arrow"></i>
                </div>
              </div>
            </div>
            <b-row class="mr-4">
              <b-col lg="6" xs="12">
                <h3 class="mb-4"><span class="fw-bold">Internal Referrals & Production</span></h3>
                <Widget>
                  <p>These are patients on your schedule <span class="fw-semi-bold">TODAY</span> who have referred other
                    patients and their <span class="fw-semi-bold">completed production $ values</span></p>
                  <p>To view details of which patients were referred and their individual completed production in your
                    office, click on the link in the column <span class="fw-semi-bold"># of Patients Referred</span>.
                  </p>
                  <div class="table-resposive">
                    <table class="table" v-if="internalRefferals && internalRefferals.length > 0">
                      <thead>
                        <tr>
                          <th>Patient on Schedule</th>
                          <th>Operatory</th>
                          <th class="text-center"># of Patients Referred</th>
                          <th>Total Value of Completed Production</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in internalRefferals" :key="index">
                          <td class=""><a href="#"
                              @click="gotoPatientPage(item.ReferredFromPatientPatNum)">{{item.ReferredFromPatient}}</a>
                          </td>
                          <td class="">{{item.OpName}}</td>
                          <td class="text-center"><a href="#"
                              @click="showPatientsReferredBy(internalRefferalsRaw, item.ReferredFromPatientPatNum)">{{item.NumOfPatientsReferred}}</a>
                          </td>
                          <td class="text-success fw-semi-bold">{{item.NetProduction |
                            money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Widget>
              </b-col>
              <b-col lg="6" xs="12">
                <h3 class="mb-4"><span class="fw-bold">Today's Birthdays on Schedule</span></h3>
                <Widget>
                  <v-client-table v-if="birthdaysOnScheduleData" :data="birthdaysOnScheduleData"
                    :columns="birthdaysOnScheduleColumns" :options="birthdaysOnScheduleOptions">
                    <div slot="h__Patient">Patient</div>
                    <div slot="h__Birthdate">Birthdate</div>
                    <div slot="h__OrthoCoverage">Age</div>
                    <div slot="h__OpName">Operatory</div>

                    <div slot="Patient" slot-scope="props">
                      <a href="#" @click="gotoPatientPage(props.row.PatNum)">{{props.row.Patient}}</a>
                    </div>

                    <div slot="Birthdate" slot-scope="props">
                      {{props.row.Birthdate | dateformat(dateFormatStr)}}
                    </div>
                  </v-client-table>
                </Widget>
              </b-col>
            </b-row>
          </div>

    <MetricsExplainerModal :focus-key="explainerKey" />

    <b-modal ref="new-patients-today-details" id="new-patients-today-details" size="lg" body-class="bg-white"
      title="Large modal" hide-footer scrollable>
      <template #modal-title>
        New Patients Today: <span class="fw-bold text-darkblue">{{newPatientsToday.length}}</span>
      </template>
      <b-container fluid>
        <Widget v-if="allSettings">
          <p><span class="glyphicon glyphicon-ok text-success fw-semi-bold"></span> = Appointment Completed</p>
          <p><span class="fa fa-calendar fw-semi-bold"></span> = Appointment Scheduled</p>
          <div class="table-resposive">
            <v-client-table v-if="newPatientsToday" :data="newPatientsToday" :columns="newPatientsColumns"
              :options="newPatientsOptions">
              <div slot="h__AppointmentStatus">Appointment Status</div>
              <div slot="h__Patient">Patient</div>
              <div slot="h__Provider">Provider</div>
              <div slot="h__AppointmentDescription">Appointment Description</div>
              <div slot="h__NetAppointmentValue">$ Net Appointment Value</div>

              <div slot="AppointmentStatus" slot-scope="props">
                <b-tooltip class="tool_tip" :target="`aptcomplete-${props.row.PatNum}`" placement="righttop"
                  triggers="hover">
                  Appointment Completed
                </b-tooltip>
                <b-tooltip class="tool_tip" :target="`aptscheduled-${props.row.PatNum}`" placement="righttop"
                  triggers="hover">
                  Appointment Scheduled
                </b-tooltip>
                <span class="glyphicon glyphicon-ok text-success fw-semi-bold" v-if="props.row.AptStatus === 2"
                  :id="`aptcomplete-${props.row.PatNum}`"></span>
                <span class="fa fa-calendar fw-semi-bold" v-if="props.row.AptStatus === 1"
                  :id="`aptscheduled-${props.row.PatNum}`"></span>
              </div>

              <div slot="Patient" slot-scope="props">
                <a href="#" @click="gotoPatientPage(props.row.PatNum)">{{props.row.Patient}}</a>
              </div>

              <div slot="Provider" slot-scope="props">
                {{props.row.Provider}}
              </div>

              <div slot="AppointentDescription" slot-scope="props">
                {{props.row.AppointentDescription}}
              </div>

              <div slot="NetAppointmentValue" slot-scope="props">
                {{props.row.NetAppointmentValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
              </div>
            </v-client-table>
          </div>
        </Widget>
      </b-container>
    </b-modal>

    <b-modal ref="new-patients-month-details" id="new-patients-month-details" size="lg" body-class="bg-white"
      title="Large modal" hide-footer scrollable>
      <template #modal-title>
        New Patients this month: <span class="fw-bold text-darkblue">{{newPatientsMTD.length}}</span>
      </template>
      <b-container fluid>
        <Widget v-if="allSettings">
          <p><span class="glyphicon glyphicon-ok text-success fw-semi-bold"></span> = Appointment Completed</p>
          <p><span class="fa fa-calendar fw-semi-bold"></span> = Appointment Scheduled</p>
          <div class="table-resposive">
            <v-client-table v-if="newPatientsMTD" :data="newPatientsMTD" :columns="newPatientsColumns"
              :options="newPatientsOptions">
              <div slot="h__AppointmentStatus">Appointment Status</div>
              <div slot="h__Patient">Patient</div>
              <div slot="h__Provider">Provider</div>
              <div slot="h__AppointmentDescription">Appointment Description</div>
              <div slot="h__NetAppointmentValue">$ Net Appointment Value</div>

              <div slot="AppointmentStatus" slot-scope="props">
                <b-tooltip class="tool_tip" :target="`aptcomplete-${props.row.PatNum}`" placement="righttop"
                  triggers="hover">
                  Appointment Completed
                </b-tooltip>
                <b-tooltip class="tool_tip" :target="`aptscheduled-${props.row.PatNum}`" placement="righttop"
                  triggers="hover">
                  Appointment Scheduled
                </b-tooltip>
                <span class="glyphicon glyphicon-ok text-success fw-semi-bold" v-if="props.row.AptStatus === 2"
                  :id="`aptcomplete-${props.row.PatNum}`"></span>
                <span class="fa fa-calendar fw-semi-bold" v-if="props.row.AptStatus === 1"
                  :id="`aptscheduled-${props.row.PatNum}`"></span>
              </div>

              <div slot="Patient" slot-scope="props">
                <a href="#" @click="gotoPatientPage(props.row.PatNum)">{{props.row.Patient}}</a>
              </div>

              <div slot="Provider" slot-scope="props">
                {{props.row.Provider}}
              </div>

              <div slot="AppointentDescription" slot-scope="props">
                {{props.row.AppointentDescription}}
              </div>

              <div slot="NetAppointmentValue" slot-scope="props">
                {{props.row.NetAppointmentValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
              </div>
            </v-client-table>
          </div>
        </Widget>
      </b-container>
    </b-modal>

    <b-modal ref="hygience-seen-today-details" id="hygience-seen-today-details" size="lg" body-class="bg-white"
      title="Large modal" hide-footer scrollable>
      <template #modal-title>
        Hygiene Re-Appointment Details For Today
      </template>
      <b-container fluid>
        <Widget v-if="allSettings">
          <p>This is a list of patients who have completed their Hygiene appointments today. </p>
          <p>These completed hygiene appointments include <span class="fw-semi-bold">Adult Prophy, Child Prophy, Perio
              Maintenance, and Scaling & Root Planing.</span></p>
          <p>The <span class="fw-semi-bold">Next Appointment Date</span> column shows when their next recall appointment
            is set.</p>
          <p>If one isn't set, the next <span class="fw-semi-bold">Due date</span> is displayed. </p>
          <div class="table-resposive">
            <v-client-table v-if="hygieneSeenToday" :data="hygieneSeenToday" :columns="hygieneColumns"
              :options="hygieneOptions">
              <div slot="h__Patient">Patient</div>
              <div slot="h__DateDue">Next Appointment Date</div>
              <div slot="h__Provider">Provider</div>
              <div slot="h__Followup"></div>

              <div slot="Patient" slot-scope="props">
                <a href="#" @click="gotoPatientPage(props.row.PatNum)">{{props.row.Patient}}</a>
              </div>

              <div slot="DateDue" slot-scope="props">
                <span v-if="props.row.RecallOrScalingScheduled === null"
                  class="glyphicon glyphicon-remove-circle text-danger fw-semi-bold mr-2"><small><mark>(Due:
                      {{props.row.DateDue | dateformat(dateFormatStr)}})</mark></small></span>
                <span v-if="props.row.RecallOrScalingScheduled !== null"><mark>{{props.row.RecallOrScalingScheduled |
                    dateformat(dateFormatStr)}}</mark></span>
              </div>

              <div slot="Provider" slot-scope="props">
                {{props.row.Provider}}
              </div>

              <div slot="Followup" slot-scope="props">
                <b-dropdown v-if="props.row.RecallOrScalingScheduled === null" id="dropdown-form" boundary="window"
                  text="Initiate Follow-up" variant="dark" size="xs" class="not-set-dropdown" ref="ifdropdown">
                  <b-dropdown-form>
                    <b-form-group label="Start Following Up On:" label-for="date-for-followup">
                      <DatePicker v-model="hygieneFollowupDate[index]" lang="en" :format="dateFormatStr"
                        :not-before="notBefore" placeholder="Select a Date" input-class="form-control" append-to-body>
                        <i class="glyphicon glyphicon-th" slot="calendar-icon" />
                      </DatePicker>
                    </b-form-group>
                    <b-button variant="primary" size="sm">Save</b-button>
                  </b-dropdown-form>
                </b-dropdown>
              </div>
            </v-client-table>
          </div>
        </Widget>
      </b-container>
    </b-modal>

    <b-modal ref="hygience-reappt-today-details" id="hygience-reappt-today-details" size="lg" body-class="bg-white"
      title="Large modal" hide-footer scrollable>
      <template #modal-title>
        Hygiene Re-Appointment Details For Today
      </template>
      <b-container fluid>
        <Widget v-if="allSettings">
          <p>This is a list of patients who came in today for their hygiene appointment <span
              class="fw-semi-bold">AND</span> have scheduled their next recall/hygiene appointment. </p>
          <div class="table-resposive">
            <v-client-table v-if="hygieneReapptToday" :data="hygieneReapptToday" :columns="hygieneColumns"
              :options="hygieneOptions">
              <div slot="h__Patient">Patient</div>
              <div slot="h__DateDue">Next Appointment Date</div>
              <div slot="h__Provider">Provider</div>
              <div slot="h__Followup"></div>

              <div slot="Patient" slot-scope="props">
                <a href="#" @click="gotoPatientPage(props.row.PatNum)">{{props.row.Patient}}</a>
              </div>

              <div slot="DateDue" slot-scope="props">
                <span v-if="props.row.RecallOrScalingScheduled === null"
                  class="glyphicon glyphicon-remove-circle text-danger fw-semi-bold mr-2"><small><mark>(Due:
                      {{props.row.DateDue | dateformat(dateFormatStr)}})</mark></small></span>
                <span v-if="props.row.RecallOrScalingScheduled !== null"><mark>{{props.row.RecallOrScalingScheduled |
                    dateformat(dateFormatStr)}}</mark></span>
              </div>

              <div slot="Provider" slot-scope="props">
                {{props.row.Provider}}
              </div>

              <div slot="Followup" slot-scope="props">
                <b-dropdown v-if="props.row.RecallOrScalingScheduled === null" id="dropdown-form" boundary="window"
                  text="Initiate Follow-up" variant="dark" size="xs" class="not-set-dropdown" ref="ifdropdown">
                  <b-dropdown-form>
                    <b-form-group label="Start Following Up On:" label-for="date-for-followup">
                      <DatePicker v-model="hygieneFollowupDate[index]" lang="en" :format="dateFormatStr"
                        :not-before="notBefore" placeholder="Select a Date" input-class="form-control" append-to-body>
                        <i class="glyphicon glyphicon-th" slot="calendar-icon" />
                      </DatePicker>
                    </b-form-group>
                    <b-button variant="primary" size="sm">Save</b-button>
                  </b-dropdown-form>
                </b-dropdown>
              </div>
            </v-client-table>
          </div>
        </Widget>
      </b-container>
    </b-modal>

    <b-modal ref="hygience-seen-month-details" id="hygience-seen-month-details" size="lg" body-class="bg-white"
      title="Large modal" hide-footer scrollable>
      <template #modal-title>
        Hygiene Re-Appointment Details For This Month
      </template>
      <b-container fluid>
        <Widget v-if="allSettings">
          <p>This is a list of patients who have completed their Hygiene appointments this month. </p>
          <p>These completed hygiene appointments include <span class="fw-semi-bold">Adult Prophy, Child Prophy, Perio
              Maintenance, and Scaling & Root Planing.</span></p>
          <p>The <span class="fw-semi-bold">Next Appointment Date</span> column shows when their next recall appointment
            is set.</p>
          <p>If one isn't set, the next <span class="fw-semi-bold">Due date</span> is displayed. </p>
          <div class="table-resposive">
            <v-client-table v-if="hygieneSeenMTD" :data="hygieneSeenMTD" :columns="hygieneColumns"
              :options="hygieneOptions">
              <div slot="h__Patient">Patient</div>
              <div slot="h__DateDue">Next Appointment Date</div>
              <div slot="h__Provider">Provider</div>
              <div slot="h__Followup"></div>

              <div slot="Patient" slot-scope="props">
                <a href="#" @click="gotoPatientPage(props.row.PatNum)">{{props.row.Patient}}</a>
              </div>

              <div slot="DateDue" slot-scope="props">
                <span v-if="props.row.RecallOrScalingScheduled === null"
                  class="glyphicon glyphicon-remove-circle text-danger fw-semi-bold mr-2"><small><mark>(Due:
                      {{props.row.DateDue | dateformat(dateFormatStr)}})</mark></small></span>
                <span v-if="props.row.RecallOrScalingScheduled !== null"><mark>{{props.row.RecallOrScalingScheduled |
                    dateformat(dateFormatStr)}}</mark></span>
              </div>

              <div slot="Provider" slot-scope="props">
                {{props.row.Provider}}
              </div>

              <div slot="Followup" slot-scope="props">
                <b-dropdown v-if="props.row.RecallOrScalingScheduled === null" id="dropdown-form" boundary="window"
                  text="Initiate Follow-up" variant="dark" size="xs" class="not-set-dropdown" ref="ifdropdown">
                  <b-dropdown-form>
                    <b-form-group label="Start Following Up On:" label-for="date-for-followup">
                      <DatePicker v-model="hygieneFollowupDate[index]" lang="en" :format="dateFormatStr"
                        :not-before="notBefore" placeholder="Select a Date" input-class="form-control" append-to-body>
                        <i class="glyphicon glyphicon-th" slot="calendar-icon" />
                      </DatePicker>
                    </b-form-group>
                    <b-button variant="primary" size="sm">Save</b-button>
                  </b-dropdown-form>
                </b-dropdown>
              </div>
            </v-client-table>
          </div>
        </Widget>
      </b-container>
    </b-modal>

    <b-modal ref="hygience-reappt-month-details" id="hygience-reappt-month-details" size="lg" body-class="bg-white"
      title="Large modal" hide-footer scrollable>
      <template #modal-title>
        Hygiene Re-Appointment Details For This Month
      </template>
      <b-container fluid>
        <Widget v-if="allSettings">
          <p>These are patients on your schedule for hygiene showing whether or not they have their next recall
            appointment set up. </p>
          <div class="table-resposive">
            <v-client-table v-if="hygieneReapptMTD" :data="hygieneReapptMTD" :columns="hygieneColumns"
              :options="hygieneOptions">
              <div slot="h__Patient">Patient</div>
              <div slot="h__DateDue">Next Appointment Date</div>
              <div slot="h__Provider">Provider</div>
              <div slot="h__Followup"></div>

              <div slot="Patient" slot-scope="props">
                <a href="#" @click="gotoPatientPage(props.row.PatNum)">{{props.row.Patient}}</a>
              </div>

              <div slot="DateDue" slot-scope="props">
                <span v-if="props.row.RecallOrScalingScheduled === null"
                  class="glyphicon glyphicon-remove-circle text-danger fw-semi-bold mr-2"><small><mark>(Due:
                      {{props.row.DateDue | dateformat(dateFormatStr)}})</mark></small></span>
                <span v-if="props.row.RecallOrScalingScheduled !== null"><mark>{{props.row.RecallOrScalingScheduled |
                    dateformat(dateFormatStr)}}</mark></span>
              </div>

              <div slot="Provider" slot-scope="props">
                {{props.row.Provider}}
              </div>

              <div slot="Followup" slot-scope="props">
                <b-dropdown v-if="props.row.RecallOrScalingScheduled === null" id="dropdown-form" boundary="window"
                  text="Initiate Follow-up" variant="dark" size="xs" class="not-set-dropdown" ref="ifdropdown">
                  <b-dropdown-form>
                    <b-form-group label="Start Following Up On:" label-for="date-for-followup">
                      <DatePicker v-model="hygieneFollowupDate[index]" lang="en" :format="dateFormatStr"
                        :not-before="notBefore" placeholder="Select a Date" input-class="form-control" append-to-body>
                        <i class="glyphicon glyphicon-th" slot="calendar-icon" />
                      </DatePicker>
                    </b-form-group>
                    <b-button variant="primary" size="sm">Save</b-button>
                  </b-dropdown-form>
                </b-dropdown>
              </div>
            </v-client-table>
          </div>
        </Widget>
      </b-container>
    </b-modal>

    <b-modal ref="patients-referred" id="patients-referred" size="lg" body-class="bg-white" title="Large modal"
      hide-footer scrollable>
      <template #modal-title>
        Patients Referred
      </template>
      <b-container fluid>
        <Widget v-if="allSettings">
          <div class="table-resposive">
            <v-client-table v-if="referredPatientsToShow" :data="referredPatientsToShow"
              :columns="referredPatientsToShowColumns" :options="referredPatientsToShowOptions">
              <div slot="h__PatientReferredName">Patient</div>
              <div slot="h__NetProduction">Net Production</div>

              <div slot="Patient" slot-scope="props">
                <a href="#" @click="gotoPatientPage(props.row.PatNum)">{{props.row.PatientReferredName}}</a>
              </div>

              <div slot="NetProduction" slot-scope="props">
                {{props.row.NetProduction | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
              </div>
            </v-client-table>
          </div>
        </Widget>
      </b-container>
    </b-modal>

    <b-modal :ref="`today_net_production-${modalData}`" :id="`today_net_production-${modalData}`" size="lg"
      body-class="bg-white" title="Large modal" hide-footer scrollable>
      <template #modal-title>
        Net Production Today by {{getProvNameFromNum(modalData)}}
      </template>
      <b-container fluid>
        <Widget v-if="allSettings">
          <div class="table-resposive">
            <v-client-table v-if="getNetProductionTotalByProviderToday(modalData)"
              :data="getNetProductionTotalByProviderToday(modalData)" :columns="netProductionTodayByColumns"
              :options="options">

              <div slot="h__ProcCode">Procedure</div>
              <div slot="h__Descript">Description</div>
              <div slot="h__Count">Total</div>
              <div slot="h__GrossTotal">Gross Production</div>
              <div slot="h__WriteoffTotal">Writeoff</div>
              <div slot="h__AdjustmentTotal">Adjustment Total</div>
              <div slot="h__NetProduction">Net Production</div>

              <div slot="GrossTotal" slot-scope="props">
                {{props.row.GrossTotal | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
              </div>

              <div slot="WriteoffTotal" slot-scope="props">
                {{props.row.WriteoffTotal | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
              </div>

              <div slot="AdjustmentTotal" slot-scope="props">
                {{props.row.AdjustmentTotal | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
              </div>

              <div slot="NetProduction" slot-scope="props">
                <span class="fw-semi-bold">{{props.row.NetProduction |
                  money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
              </div>
            </v-client-table>
          </div>
        </Widget>
      </b-container>
    </b-modal>

    <b-modal :ref="`mtd_net_production-${modalData}`" :id="`mtd_net_production-${modalData}`" size="lg"
      body-class="bg-white" title="Large modal" hide-footer scrollable>
      <template #modal-title>
        Net Production MTD by {{getProvNameFromNum(modalData)}}
      </template>
      <b-container fluid>
        <Widget v-if="allSettings">
          <div class="table-resposive">
            <v-client-table v-if="getNetProductionTotalByProviderMTD(modalData)"
              :data="getNetProductionTotalByProviderMTD(modalData)" :columns="netProductionMTDByColumns"
              :options="options">

              <div slot="h__ProcCode">Procedure</div>
              <div slot="h__Descript">Description</div>
              <div slot="h__Count">Total</div>
              <div slot="h__GrossTotal">Gross Production</div>
              <div slot="h__WriteoffTotal">Writeoff</div>
              <div slot="h__NetProduction">Net Production</div>

              <div slot="GrossTotal" slot-scope="props">
                {{props.row.GrossTotal | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
              </div>

              <div slot="WriteoffTotal" slot-scope="props">
                {{props.row.WriteoffTotal | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
              </div>

              <div slot="NetProduction" slot-scope="props">
                <span class="fw-semi-bold">{{props.row.NetProduction |
                  money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
              </div>
            </v-client-table>
          </div>
        </Widget>
      </b-container>
    </b-modal>

    <b-modal :ref="`today_tx_planned-${modalData}`" :id="`today_tx_planned-${modalData}`" size="lg"
      body-class="bg-white" title="Large modal" hide-footer scrollable>
      <template #modal-title>
        Today's Tx Planned Procedures by {{getProvNameFromNum(modalData)}}: {{getNetTxPlannedTodayByProvider(modalData)
        | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}} | <mark>Accepted:
          {{getTxAcceptedTodayByProvider(modalData) | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</mark>
      </template>
      <b-container fluid>
        <Widget v-if="allSettings">
          <div class="table-resposive">
            <v-client-table v-if="getNetTxPlannedTodayByProviderDetails(modalData)"
              :data="getNetTxPlannedTodayByProviderDetails(modalData)" :columns="netTxPlannedTodayByColumns"
              :options="options">
              <div slot="h__Patient">Patient</div>
              <div slot="h__NetFee">Net Fee</div>
              <div slot="h__ProcCode">Procedure Code</div>
              <div slot="h__ToothSurface">Tooth-surface</div>
              <div slot="h__Descript">Description</div>
              <div slot="h__Provider">Provider</div>
              <div slot="h__AptStatus">Appointment Status</div>

              <div slot="NetFee" slot-scope="props">
                <div><span class="fw-semi-bold">{{props.row.NetFee |
                    money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></div>
              </div>

              <div slot="AptStatus" slot-scope="props">
                <b-tooltip class="tool_tip" :target="`today-aptcomplete-${props.row.Patient}`" placement="righttop"
                  triggers="hover">
                  Appointment Completed
                </b-tooltip>
                <b-tooltip class="tool_tip" :target="`today-aptscheduled-${props.row.Patient}`" placement="righttop"
                  triggers="hover">
                  Appointment Scheduled
                </b-tooltip>
                <b-tooltip class="tool_tip" :target="`today-notscheduled-${props.row.Patient}`" placement="righttop"
                  triggers="hover">
                  Not Scheduled
                </b-tooltip>
                <b-button v-if="props.row.AptStatus === 2" variant="success" class="mb-xs mr-xs btn-xs mt-xs"
                  :id="`today-aptcomplete-${props.row.Patient}`">
                  <small><strong>Completed</strong></small>
                </b-button>
                <b-button v-if="props.row.AptStatus === 1" :id="`today-aptscheduled-${props.row.Patient}`"
                  variant="success" class="mb-xs mr-xs btn-xs mt-xs">
                  <small><strong>Scheduled</strong></small>
                </b-button>
                <b-button v-if="props.row.AptStatus === null" :id="`today-notscheduled-${props.row.Patient}`"
                  variant="danger" class="mb-xs mr-xs btn-xs mt-xs">
                  <small><strong>Unscheduled</strong></small>
                </b-button>
              </div>
            </v-client-table>
          </div>
        </Widget>
      </b-container>
    </b-modal>

    <b-modal :ref="`mtd_tx_planned-${modalData}`" :id="`mtd_tx_planned-${modalData}`" size="lg" body-class="bg-white"
      title="Large modal" hide-footer scrollable>
      <template #modal-title>
        Monthly Tx Planned Procedures by {{getProvNameFromNum(modalData)}}: {{getNetTxPlannedMTDByProvider(modalData) |
        money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}} | <mark>Accepted:
          {{getTxAcceptedMTDByProvider(modalData) | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</mark>
      </template>
      <b-container fluid>
        <Widget v-if="allSettings">
          <div class="table-resposive">
            <v-client-table v-if="getNetTxPlannedMTDByProviderDetails(modalData)"
              :data="getNetTxPlannedMTDByProviderDetails(modalData)" :columns="netTxPlannedMTDByColumns"
              :options="options">
              <div slot="h__Patient">Patient</div>
              <div slot="h__NetFee">Net Fee</div>
              <div slot="h__ProcCode">Procedure Code</div>
              <div slot="h__ToothSurface">Tooth-surface</div>
              <div slot="h__Descript">Description</div>
              <div slot="h__Provider">Provider</div>
              <div slot="h__AptStatus">Appointment Status</div>

              <div slot="NetFee" slot-scope="props">
                <div><span class="fw-semi-bold">{{props.row.NetFee |
                    money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></div>
              </div>
              <div slot="AptStatus" slot-scope="props">
                <b-tooltip class="tool_tip" :target="`today-aptcomplete-${props.row.Patient}`" placement="righttop"
                  triggers="hover">
                  Appointment Completed
                </b-tooltip>
                <b-tooltip class="tool_tip" :target="`today-aptscheduled-${props.row.Patient}`" placement="righttop"
                  triggers="hover">
                  Appointment Scheduled
                </b-tooltip>
                <b-tooltip class="tool_tip" :target="`today-notscheduled-${props.row.Patient}`" placement="righttop"
                  triggers="hover">
                  Not Scheduled
                </b-tooltip>
                <b-button v-if="props.row.AptStatus === 2" variant="success" class="mb-xs mr-xs btn-xs mt-xs"
                  :id="`today-aptcomplete-${props.row.Patient}`">
                  <small><strong>Completed</strong></small>
                </b-button>
                <b-button v-if="props.row.AptStatus === 1" :id="`today-aptscheduled-${props.row.Patient}`"
                  variant="success" class="mb-xs mr-xs btn-xs mt-xs">
                  <small><strong>Scheduled</strong></small>
                </b-button>
                <b-button v-if="props.row.AptStatus === null" :id="`today-notscheduled-${props.row.Patient}`"
                  variant="danger" class="mb-xs mr-xs btn-xs mt-xs">
                  <small><strong>Unscheduled</strong></small>
                </b-button>
              </div>
            </v-client-table>
          </div>
        </Widget>
      </b-container>
    </b-modal>

    <!--

      commenting out collection breakdown by provider

    <b-modal ref="today_collection_by_provider" :id="`today_collection_by_provider`" size="lg" body-class="bg-white" title="Large modal" hide-footer>
     <template #modal-title>
        Collection Today by Provider
      </template>
      <b-container fluid>
        <Widget v-if="allSettings">
            <div class="table-resposive">
              <v-client-table v-if="collectionTodayByProvider" :data="collectionTodayByProvider" :columns="collectionTodayByProviderColumns" :options="options">
                <div slot="h__ProvNum">Provider</div>
                <div slot="h__PayAmt">Amount</div>

                <div slot="ProvNum" slot-scope="props">
                  {{getProvNameFromNum(props.row.provNum)}}
                </div>

                <div slot="PayAmt" slot-scope="props">                  
                  {{props.row.PayAmt | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
                </div>
              </v-client-table>
            </div>
          </Widget>
      </b-container>
    </b-modal>

    -->

    <!--

    <b-modal ref="mtd_collection_by_provider" :id="`mtd_collection_by_provider`" size="lg" body-class="bg-white" title="Large modal" hide-footer>
     <template #modal-title>
      Collection MTD by Provider
      </template>
      <b-container fluid>
        <Widget v-if="allSettings">
            <div class="table-resposive">
              <v-client-table v-if="collectionMTDByProvider" :data="collectionMTDByProvider" :columns="collectionMTDByProviderColumns" :options="options">
                <div slot="h__ProvNum">Provider</div>
                <div slot="h__PayAmt">Amount</div>

                <div slot="ProvNum" slot-scope="props">
                  {{getProvNameFromNum(props.row.ProvNum)}}
                </div>

                <div slot="PayAmt" slot-scope="props">                  
                  {{props.row.PayAmt | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
                </div>
              </v-client-table>
            </div>
          </Widget>
      </b-container>
    </b-modal>

    -->

    <slideout-panel></slideout-panel>

  </div>
</template>

<script>
/* eslint-disable */

import Vue from 'vue';
import ProviderProductionChart from '@/pages/Huddle/ProviderProductionChart';
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import Widget from "@/components/Widget/Widget";
import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";
import HuddleDetails from './components/HuddleDetails';
// The V1 panel (./components/AdvancedTxPlanned.vue) is no longer imported — every user gets V2
// since 2026-10-18. Its files stay for a one-line rollback until V2 has had a quiet stretch.
import AdvancedTxPlannedV2 from './components/AdvancedTxPlannedV2';
import ProceduralTracking from './components/ProceduralTracking';
import SetGoals from './components/SetGoals';
import HygieneOpportunities from './components/HygieneOpportunities';
import NewPatientReport from './components/NewPatientReport';
import ProductionTrends from './components/ProductionTrends';
import MetricInfo from '@/components/MetricInfo/MetricInfo';
import MetricsExplainerModal from './components/MetricsExplainerModal';
import { byKey as metricGlossary } from './huddleMetricGlossary';
import {
  appointmentProviderNums,
  groupAppointmentsByProviderDay,
  groupScheduleByProviderDay,
  resolveLunchMinutes,
  computeDayHours,
} from '@/utils/huddle/clinicalHours';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import mixin from '../../mixin.js';
import moment from 'moment-timezone';
import InsightMSBarChart from '@/pages/TeamInsights/components/InsightMSBarChart';
import PieChart from '@/pages/TeamInsights/components/InsightPieChart';
import ChartJSBarChart from '@/pages/TeamInsights/components/ChartJSBarChart.vue'; // Adjust the path as needed

import HuddleSkeleton from './HuddleSkeleton.vue';

export default {  
  name: 'Huddle',
  components: { DatePicker, Multiselect, Widget, ErrorDisplay, ProviderProductionChart,
    InsightMSBarChart, PieChart, ChartJSBarChart, HuddleSkeleton, MetricInfo, MetricsExplainerModal },
  mixins: [mixin],

  created() {
    if(this.allSettings)
      this.init();
  },

  mounted() {
    //this.initCharts();
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })    
  },

  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },

  data() {
    return {
     busy: false,
     refreshKey: false,
     // Plain-language copy for the production numbers, keyed by slug. See huddleMetricGlossary.js.
     metricGlossary,
     // Which glossary section the explainer modal opens to. Null = open at the top.
     explainerKey: null,
     dateRange: 'Month-to-Date', // Example date range
     timeRange: 'Current Month', // Example time range
     huddleDate: this.$route.query.d ? moment(this.$route.query.d).format('MM/DD/YYYY') : moment().format('MM/DD/YYYY'),
     windowWidth: window.innerWidth,
     loadingStatus: false,
     results: [],
     providerGoals: [],
     hygieneFollowupDate: [],
     notBefore: new Date(),
     newPatientsColumns: ['AppointmentStatus', 'Patient', 'Provider', 'AppointmentDescription', 'NetAppointmentValue'],
     hygieneColumns: ['Patient', 'DateDue', 'Provider'],
     referredPatientsToShowColumns: ['PatientReferredName', 'NetProduction'],
     birthdaysOnScheduleColumns: ['Patient', 'Birthdate', 'Age', 'OpName'],
     netProductionTodayByColumns: ['ProcCode', 'Descript', 'Count', 'GrossTotal', 'WriteoffTotal', 'AdjustmentTotal', 'NetProduction'],
     netProductionMTDByColumns: ['ProcCode', 'Descript', 'Count', 'GrossTotal', 'WriteoffTotal', 'NetProduction'],
     netTxPlannedTodayByColumns: ['Patient', 'NetFee', 'ProcCode', 'ToothSurface', 'Descript', 'Provider', 'AptStatus'],
     netTxPlannedMTDByColumns: ['Patient', 'NetFee', 'ProcCode', 'ToothSurface', 'Descript', 'Provider', 'AptStatus'],
     collectionTodayByProviderColumns: ['ProvNum', 'PayAmt'],
     collectionMTDByProviderColumns: ['ProvNum', 'PayAmt'],
     unscheduledFamilyRecallsOptions: {
        filterable: false,
        skin:'table',
        sortable: [],
        perPage: 10,
        sortByColumn: false,
        pagination: { chunk: 10, dropdown: false },
     },
     options: {
        filterable: [],
        skin:'table',
        sortable: [],
        perPage: 10,
        sortByColumn: false,
        pagination: { chunk: 10, dropdown: false },
      },
      newPatientsOptions: {
        filterable: [],
        skin:'table',
        sortable: [],
        perPage: 10,
        sortByColumn: false,
        pagination: { chunk: 10, dropdown: false },
      },
      hygieneOptions: {
        skin:'table',
        sortable: [],
        perPage: 10,
        filterByColumn: false,
        filterable: ['Provider'],
        sortByColumn: false,
        pagination: { chunk: 10, dropdown: false },
        texts: {
            filter: 'Filter by Provider'
            //count:' '
          },
      },

      barChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            gridLines: { display: false },
            ticks: {
              autoSkip: true,
              maxTicksLimit: 5,
              maxRotation: 45,
              minRotation: 0,
              fontFamily: "'Inter', 'Segoe UI', Roboto, -apple-system, sans-serif",
              fontSize: 11,
              fontColor: '#64748b'
            },
            categoryPercentage: 0.5,
            barPercentage: 0.6
          }],
          yAxes: [{
            gridLines: { display: false },
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 5,
              fontFamily: "'Inter', 'Segoe UI', Roboto, -apple-system, sans-serif",
              fontSize: 11,
              fontColor: '#64748b'
            }
          }]
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            boxWidth: 12,
            padding: 12,
            fontFamily: "'Inter', 'Segoe UI', Roboto, -apple-system, sans-serif",
            fontSize: 11,
            fontColor: '#334155'
          }
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
              const value = tooltipItem.yLabel; // Get the raw value from the tooltip
              // Format the value as currency with 2 decimal places, assuming USD for simplicity
              const currencySymbol = this.allSettings?.GENERAL_CURRENCY_SYMBOL?.PropertyValue || '$';
              const formattedValue = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(value);
              return `${datasetLabel}: ${currencySymbol}${formattedValue.replace(currencySymbol, '')}`; // Remove duplicate symbol if needed
            }.bind(this) // Bind `this` to access `allSettings` from the Vue component
          }
        }
      },

      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom', // Force legend to bottom for mobile compatibility
          align: 'center', // Center the legend items horizontally
          fullWidth: true, // Ensures the legend spans the full width of the chart
          labels: { 
            padding: 10, 
            boxWidth: 15,
            font: {
             size: 12
            },
            textAlign: 'center' // Explicitly center the text if needed
          }
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              const label = data.labels[tooltipItem.index] || '';
              const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              // Get the currency symbol from allSettings or use '$' as fallback
              const currencySymbol = this.allSettings?.GENERAL_CURRENCY_SYMBOL?.PropertyValue || '$';
              // Format the value as currency with 2 decimal places
              const formattedValue = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(value);
              // Return the label and formatted value, ensuring the currency symbol is included only once
              return `${label}: ${currencySymbol}${formattedValue.replace(currencySymbol, '').trim()}`;
            }.bind(this) // Bind `this` to access `allSettings` from the Vue component
          }
        }
      },
      
      birthdaysOnScheduleOptions: {
        filterable: [],
        skin:'table',
        sortable: [],
        perPage: 10,
        sortByColumn: false,
        pagination: { chunk: 10, dropdown: false },
      },
      referredPatientsToShowOptions: {
        filterable: [],
        skin:'table',
        sortable: [],
        perPage: 10,
        sortByColumn: false,
        pagination: { chunk: 10, dropdown: false },
      },      
      referredPatientsToShow: [],
      chartStyle: {
        width: '100%', height: '180px'        
      },
      modalData: null
    };
  },
  methods: {

    ...mapActions('huddle', ['getHuddleData']),

    async init() {          

      let q = this.$route.query.d ? this.$route.query.d : this.huddleDate;      

      let validDate = this.$route.query.d ? moment(q, "YYYY-MM-DD", true).isValid() : moment(q, "MM/DD/YYYY", true).isValid();

      if(!validDate) {        
        this.$toast.error(`Invalid date. Please try again`);
        return false;
      }

      let payload = {
          siteID: this.siteID,
          _date: moment(q).format('YYYY-MM-DD'),
          country: localStorage.getItem('country') || 'USA',
          timezone: this.allSettings?.GENERAL_TIMEZONE?.PropertyValue || 'America/New_York'
      };

      //console.log('payload', JSON.stringify(payload, null, 2));

      try {
        this.busy = true; 
        let mainData = await this.getHuddleData(payload);
        Vue.set(this, 'results', mainData);
        //console.log('results', mainData);
        this.busy = false;
      } catch(err) {
        this.busy = false;
      }      
    },

    async loadData() {
      this.$router.push({ name: 'Huddle', query: { d:  moment(this.huddleDate).format('YYYY-MM-DD')} });
    },

    onResize() {
      this.windowWidth = window.innerWidth;
      // Update chart options dynamically if needed
      this.chartOptions.legend.position = this.windowWidth < 768 ? 'bottom' : 'right';
    },

    subtractMonth(d) {
      return moment(d).subtract(1, 'months');
    },

    hideModal(ref) {
      this.$refs[ref].hide();
    },

    showModal(ref) {
      this.$bvModal.show(ref);
    },

    showModal(e, ref, data) {      
      e.preventDefault();
      //console.log(`show modal called with temp: ${e}, ref: ${ref} and data: ${data}`);
      this.modalData = data;
      Vue.nextTick(() => {
        this.$bvModal.show(ref);
      });      
    },

    gotoPatientPage(patNum) {
      let teamioPatientID = `${this.siteID}-${patNum}`;
      let routeData = this.$router.resolve({name: 'patientprofile', params: {patientID:  teamioPatientID}});
      window.open(routeData.href, '_blank');
    },

    getProcTypeForPanoFmx(proccode) {
      let t = '';
      switch(proccode) {
        case 'D0330': t = 'PANO'; break;
        case 'D0210': t = 'FMX'; break;
        case '02601': t = 'PANO'; break; // CANADA
        case '02101': t = 'FMX'; break; // CANADA
        case '02102': t = 'FMX'; break; // CANADA
        case null: t = ''; break;
      }
      return t;
    },

    isPanoElligible(row) {
      let d = this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD');
      if(row.LastPanoDate !== null && moment().diff(row.LastPanoDate, 'days') > 0 && moment().diff(row.DateDue, 'days') >= 0)
        return true;
      else
        return false;
    },

    isBwElligible(row) {
      let d = this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD');
      if(row.LastBWDate !== null && moment().diff(row.LastBWDate, 'days') > 0 && moment().diff(row.DateDue, 'days') >= 0)
        return true;
      else
        return false;
    },

    showPatientsReferredBy(referralsData, patNum) {
      let a = _.groupBy(referralsData, "ReferredFromPatNum");
      this.$set(this, "referredPatientsToShow", a[patNum] );
      this.$bvModal.show('patients-referred');
    },

    getNetProductionToday(provNum) {
      if(this.grossProductionTodayByProvider && this.writeOffTodayByProvider && this.adjustmentsTodayByProvider) {
        let gpKey = _.findKey(this.grossProductionTodayByProvider, { 'provNum': provNum});
        let woKey = _.findKey(this.writeOffTodayByProvider, { 'provNum': provNum});
        let adjKey = _.findKey(this.adjustmentsTodayByProvider, { 'provNum': provNum});
        let grossProduction = gpKey && this.grossProductionTodayByProvider.length > 0  ? this.grossProductionTodayByProvider[parseInt(gpKey)].grossProduction : 0;
        let writeOff = woKey && this.writeOffTodayByProvider.length > 0 ? this.writeOffTodayByProvider[parseInt(woKey)].writeOff : 0;
        let adjustments = adjKey && this.adjustmentsTodayByProvider.length > 0 ? this.adjustmentsTodayByProvider[parseInt(adjKey)].adjAmt : 0;
        return  grossProduction - writeOff + adjustments;
      } else
        return 0;
    },

    getNetProductionMTD(provNum) {
      if(this.grossProductionMTDByProvider && this.writeOffMTDByProvider && this.adjustmentsMTDByProvider) {
        let gpKey = _.findKey(this.grossProductionMTDByProvider, { 'provNum': provNum});
        let woKey = _.findKey(this.writeOffMTDByProvider, { 'provNum': provNum});
        let adjKey = _.findKey(this.adjustmentsMTDByProvider, { 'provNum': provNum});
        let grossProduction = gpKey && this.grossProductionMTDByProvider.length > 0 ? this.grossProductionMTDByProvider[parseInt(gpKey)].grossProduction : 0;
        let writeOff = woKey && this.writeOffMTDByProvider.length > 0 ? this.writeOffMTDByProvider[parseInt(woKey)].writeOff : 0;
        let adjustments = adjKey && this.adjustmentsMTDByProvider.length > 0 ? this.adjustmentsMTDByProvider[parseInt(adjKey)].adjustments : 0;
        return  grossProduction - writeOff + adjustments;
      } else
        return 0;
    },

    /**
     * Clinical hours for a provider on the current huddle date.
     * The rule lives in src/utils/huddle/clinicalHours.js (shared with Advanced Production Trends): the provider's
     * Open Dental schedule for the day (stretched to the first / latest-ending appointment if they fall outside it),
     * otherwise first appointment to the latest appointment end; minus the larger of the Set Goals lunch and the
     * empty gap in a split schedule (no default lunch for a provider without one set).
     * Uses clinicalHoursAppointmentsToday (dataToDisplay[13]) - ALL appointments (scheduled, completed, broken),
     * counted for the dentist (ProvNum) AND the hygienist (ProvHyg) - and providerScheduleToday (dataToDisplay[15]).
     * @param {string|number} provNum - Provider number
     * @returns {number} Clinical hours (decimal)
     */
    getClinicalHoursToday(provNum) {
      const prov = Number(provNum);

      // Each row is already a unique appointment (DISTINCT in the query)
      const providerAppointments = (this.clinicalHoursAppointmentsToday || []).filter(
        apt => apt.AptNum && apt.AptDateTime && appointmentProviderNums(apt).includes(prov)
      );
      if (providerAppointments.length === 0) {
        return 0;
      }

      // Everything in dataToDisplay is for the one huddle date, so a single day bucket is enough
      const DAY = 'huddleDay';
      const appts = (groupAppointmentsByProviderDay(providerAppointments, () => DAY)[DAY] || {})[prov] || [];

      const scheduleByDay = groupScheduleByProviderDay(
        this.providerScheduleToday.filter(row => Number(row.ProvNum) === prov)
      );
      const blocks = Object.keys(scheduleByDay).reduce((all, day) => all.concat(scheduleByDay[day][prov] || []), []);

      // isoWeekday of the huddle date: 1=Mon ... 6=Sat, 7=Sun
      const huddleMoment = this.$route.query.d
        ? moment(this.$route.query.d)
        : moment();
      const lunchMinutes = resolveLunchMinutes(
        this.huddleGoals ? this.huddleGoals.providerLunchDuration : null,
        provNum,
        huddleMoment.isoWeekday()
      );

      return computeDayHours({ appts, blocks, lunchMinutes }).hours;
    },

    /**
     * Get $/hr for a provider's completed production today
     * @param {string|inumber} provNum - Provider number
     * @returns {number|null} Production per hour, or null if no clinical hours
     */
    getProductionPerHourToday(provNum) {
      const netProduction = this.getNetProductionToday(provNum);
      const clinicalHours = this.getClinicalHoursToday(provNum);

      if (clinicalHours <= 0) {
        return null;
      }

      return netProduction / clinicalHours;
    },

    /**
     * Get scheduled $/hr for a provider today
     * @param {string|number} provNum - Provider number
     * @returns {number|null} Scheduled production per hour, or null if no clinical hours
     */
    getScheduledProductionPerHourToday(provNum) {
      const scheduledProduction = this.getScheduledProductionToday(provNum);
      const clinicalHours = this.getClinicalHoursToday(provNum);

      if (clinicalHours <= 0) {
        return null;
      }

      return scheduledProduction / clinicalHours;
    },

    getScheduledProductionToday(provNum) {
      if(this.scheduledProductionTodayByProvider && this.grossProductionTodayByProvider) {
        let spKey = _.findKey(this.scheduledProductionTodayByProvider, { 'provNum': provNum});
        let netProductionTodayByProvider = this.getNetProductionToday(provNum);
        let scheduledProductionTodayByProvider = spKey && this.scheduledProductionTodayByProvider.length > 0 ? this.scheduledProductionTodayByProvider[parseInt(spKey)].scheduledProduction : 0;
        return scheduledProductionTodayByProvider + netProductionTodayByProvider;
      } else
        return 0;
    },

    getScheduledProductionThisMonth(provNum) {
      //console.log(JSON.stringify(provider));
      if(this.scheduledProductionMTDByProvider && this.grossProductionMTDByProvider) {
        let spKey = _.findKey(this.scheduledProductionMTDByProvider, { 'provNum': provNum});
        //console.log(spKey);
        let netProductionMTDByProvider = this.getNetProductionMTD(provNum);
        //console.log(netProductionMTDByProvider);
        let scheduledProductionMTDByProvider = spKey && this.scheduledProductionMTDByProvider.length > 0 ? this.scheduledProductionMTDByProvider[parseInt(spKey)].scheduledProduction : 0;
        //console.log(scheduledProductionMTDByProvider);
        return scheduledProductionMTDByProvider + netProductionMTDByProvider;
      } else
        return 0;
    },

    getMonthlyProductionGoal(provNum) {
      if (!this.monthlyProductionGoalByProvider || this.monthlyProductionGoalByProvider.length === 0) {
        return 0;
      }
      const row = this.monthlyProductionGoalByProvider.find(r => String(r.ProvNum) === String(provNum));
      return row && row.MonthlyGoal ? row.MonthlyGoal : 0;
    },

    /**
     * Caption percent for the goal bars: true percentage, NOT capped at 100 - beating
     * the goal should read as "101% of goal". Floored at 0 so a negative net production
     * (heavy adjustments) doesn't render "-8% of goal".
     */
    goalPercent(value, goal) {
      if (!goal || goal <= 0) return 0;
      return Math.max(0, Math.round(((Number(value) || 0) / goal) * 100));
    },

    /**
     * Open the "what do these numbers mean?" breakdown. Pass a glossary key to land on that
     * section (from an info icon), or nothing to open at the top (from the header button).
     */
    openMetricsExplainer(key = null) {
      this.explainerKey = key;
      this.$bvModal.show('huddle-metrics-explainer');
    },

    getNetProductionTotalByProviderToday(provNum) {
      if(this.grossProductionTotalByProviderToday && this.writeoffTotalByProviderToday) {
        let gpData = this.grossProductionTotalByProviderToday[provNum];
        let _this = this;
        _.forEach(gpData, function (n) {
          
          let indexToChange = _.findIndex(_this.grossProductionTotalByProviderToday[provNum], { ProcCode: n.ProcCode });

          let h1 = _.find(_this.writeoffTotalByProviderToday[provNum], { ProcCode: n.ProcCode });
          let h2 = _.find(_this.adjustmentTotalByProviderToday[provNum], { ProcCode: n.ProcCode });

          if (h1) {
            _this.grossProductionTotalByProviderToday[provNum][indexToChange].WriteoffTotal = h1.WriteoffTotal;
          }
          else {
            _this.grossProductionTotalByProviderToday[provNum][indexToChange].WriteoffTotal = 0;  
          }

          if (h2) {
            _this.grossProductionTotalByProviderToday[provNum][indexToChange].AdjustmentTotal = h2.AdjustmentTotal;
          }
          else {
            _this.grossProductionTotalByProviderToday[provNum][indexToChange].AdjustmentTotal = 0;  
          }

          _this.grossProductionTotalByProviderToday[provNum][indexToChange].NetProduction = _this.grossProductionTotalByProviderToday[provNum][indexToChange].GrossTotal - _this.grossProductionTotalByProviderToday[provNum][indexToChange].WriteoffTotal + _this.grossProductionTotalByProviderToday[provNum][indexToChange].AdjustmentTotal;

        });
        return _this.grossProductionTotalByProviderToday[provNum];
      }
    },

    getNetProductionTotalByProviderMTD(provNum) {
      if(this.grossProductionTotalByProviderMTD && this.writeoffTotalByProviderMTD) {
        let gpData = this.grossProductionTotalByProviderMTD[provNum];
        let _this = this;
        _.forEach(gpData, function (n) {
          let indexToChange = _.findIndex(_this.grossProductionTotalByProviderMTD[provNum], { ProcCode: n.ProcCode });
          let h1 = _.find(_this.writeoffTotalByProviderMTD[provNum], { ProcCode: n.ProcCode });
          let h2 = _.find(_this.adjustmentTotalByProviderMTD[provNum], { ProcCode: n.ProcCode });
          if (h1) {
            _this.grossProductionTotalByProviderMTD[provNum][indexToChange].WriteoffTotal = h1.WriteoffTotal;
          }
          else{
            _this.grossProductionTotalByProviderMTD[provNum][indexToChange].WriteoffTotal = 0;  
          }

          if (h2) {
            _this.grossProductionTotalByProviderMTD[provNum][indexToChange].AdjustmentTotal = h2.AdjustmentTotal;
          }
          else {
            _this.grossProductionTotalByProviderMTD[provNum][indexToChange].AdjustmentTotal = 0;  
          }

          _this.grossProductionTotalByProviderMTD[provNum][indexToChange].NetProduction = _this.grossProductionTotalByProviderMTD[provNum][indexToChange].GrossTotal -_this.grossProductionTotalByProviderMTD[provNum][indexToChange].WriteoffTotal + _this.grossProductionTotalByProviderMTD[provNum][indexToChange].AdjustmentTotal;


        });
        return _this.grossProductionTotalByProviderMTD[provNum];
      }
    },

    getCacheTotal(cache, prefix) {
      const ret = Object.keys(cache).filter(
        t => t.startsWith(prefix));
      let total = 0;
      ret.forEach(function(key) {
        total = total + parseInt(cache[key], 10);
      });
      return total;
    },

    getNetTxPlannedTodayByProvider(provNum) {
      if(this.netTxPlannedTodayByProvider) {
        let a = this.netTxPlannedTodayByProvider.filter(p => p.provNum === provNum);
        if(a.length) {
          return a[0].netTxPlanned;
        }
      }
    },

    getNetTxPlannedMTDByProvider(provNum) {
      if(this.netTxPlannedMTDByProvider) {
        let a = this.netTxPlannedMTDByProvider.filter(p => p.provNum === provNum);
        if(a.length) {
          return a[0].netTxPlanned;
        }
      }
    },

    getNetTxPlannedTodayByProviderDetails(provNum) {
      if(this.netTxPlannedTodayRaw) {
        return this.netTxPlannedTodayRaw.filter(p => p.ProvNum === parseInt(provNum,10));
      }
    },

    getNetTxPlannedMTDByProviderDetails(provNum) {
      if(this.netTxPlannedMTDRaw) {
        return this.netTxPlannedMTDRaw.filter(p => p.ProvNum === parseInt(provNum,10));
      }
    },

    getTxAcceptedTodayByProvider(provNum) {
      if(this.netTxPlannedTodayByProvider) {
        let a = this.netTxPlannedTodayByProvider.filter(p => p.provNum === provNum);
        if(a.length) {
          return a[0].txAccepted;
        }
      }
    },

  

    getTxAcceptedMTDByProvider(provNum) {
      if(this.netTxPlannedMTDByProvider) {
        let a = this.netTxPlannedMTDByProvider.filter(p => p.provNum === provNum);
        if(a.length) {
          return a[0].txAccepted;
        } else
          return 0;
      }
    },


    getProvNumFormProv(provName) {
      let ret = this.providers.filter(p => p.LName + ", " + p.FName === provName);
      if(ret.length)
        return ret[0].ProvNum;
    },

    getProvNameFromNum(provNum) {
      let ret = this.providers.filter(p => p.ProvNum === parseInt(provNum, 10));
      if(ret.length)
        return ret[0].LName + ", " + ret[0].FName;
    },

    getAbbrFromProvNum(provNum) {
      let ret = this.providers.filter(p => p.ProvNum === parseInt(provNum, 10));
      if(ret.length)
        return ret[0].Abbr;
    },

    async viewHuddleDetails(event, props) {
      event.preventDefault();
      //Vue.set(this.loadingStatus, true);
      var _this = this;
      try {
        const huddleDetailsHandle = this.$showPanel({
          component : HuddleDetails,
          openOn: 'right',
          width: this.windowWidth * 0.95,
          cssClass: 'HuddleDetailsPanelClass',
          disableBgClick: true,
          disableEscClick: true,
          props: {
              d: this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD'),
          }
        });

        huddleDetailsHandle.promise.then(async(result) => {
          //console.log(`Got result: ${JSON.stringify(result, null, 4)}`);
          //Vue.set(this.loadingStatus, false);
        });
      } catch(err) {
        //Vue.set(this.loadingStatus, false);
        console.log(err);
      } finally {
        //console.log("finally");
      }
    },

    /**
     * Treatment Presented vs Accepted — the V2 panel for every user (cut over
     * 2026-10-18). Same endpoint as V1, plus provider comparison, patient
     * acceptance, an Unscheduled bucket and a unified drill-down.
     *
     * Rollback: mount `AdvancedTxPlanned` (V1, still in ./components) here again.
     */
    async viewAdvancedTxPlanned(event) {
      event.preventDefault();
      try {
        const handle = this.$showPanel({
          component: AdvancedTxPlannedV2,
          openOn: 'right',
          width: this.windowWidth * 0.95,
          cssClass: 'HuddleDetailsPanelClass',
          disableBgClick: true,
          disableEscClick: true,
          props: {
            d: this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD'),
          }
        });

        handle.promise.then(() => {
          // Nothing to do on close — the panel owns its own state.
        });
      } catch(err) {
        this.$toast.error(err);
        console.log(err);
      }
    },

    async viewProductionTrends(event) {
      event.preventDefault();
      try {
        const productionTrendsHandle = this.$showPanel({
          component: ProductionTrends,
          openOn: 'right',
          width: this.windowWidth * 0.95,
          cssClass: 'HuddleDetailsPanelClass',
          disableBgClick: true,
          disableEscClick: true,
          props: {
            d: this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD'),
            huddleGoals: this.huddleGoals,
          }
        });

        productionTrendsHandle.promise.then(async(result) => {
        });
      } catch(err) {
        this.$toast.error(err);
        console.log(err);
      }
    },

    async viewProceduralTracking(event, props) {
      event.preventDefault();
      //Vue.set(this.loadingStatus, true);
      var _this = this;
      try {
        const proceduralTrackingHandle = this.$showPanel({
          component : ProceduralTracking,
          openOn: 'right',
          width: this.windowWidth * 0.95,
          cssClass: 'HuddleDetailsPanelClass',
          disableBgClick: true,
          disableEscClick: true,
          props: {              
              proceduresTracking: this.huddleGoals && this.huddleGoals.proceduresTracking ? this.huddleGoals.proceduresTracking : []
          }
        });

        proceduralTrackingHandle.promise.then(async(result) => {
          //console.log(`Got result: ${JSON.stringify(result, null, 4)}`);
          //Vue.set(this.loadingStatus, false);
        });
      } catch(err) {
        //Vue.set(this.loadingStatus, false);
        this.$toast.error(err);
        console.log(err);
      } finally {
        //console.log("finally");
      }
    },

    async setGoals(event, props) {
      event.preventDefault();
      //Vue.set(this.loadingStatus, true);
      var _this = this;
      try {
        const setGoalsHandle = this.$showPanel({
          component : SetGoals,
          openOn: 'right',
          width: 1850,
          disableBgClick: true,
          disableEscClick: true,
          props: {
              providers: [...this.providers]
          }
        });

        setGoalsHandle.promise.then(async(result) => {
          //console.log(`Got result: ${JSON.stringify(result, null, 4)}`);
          Vue.set(this.huddleGoals, 'providerGoals', result.providerGoals);
          Vue.set(this.huddleGoals, 'monthlyNetProduction', result.monthlyNetProduction);
          Vue.set(this.huddleGoals, 'monthlyCollection', result.monthlyCollection);
          Vue.set(this.huddleGoals, 'monthlyNewPatients', result.monthlyNewPatients);
          /* I shoudn't have to do the below but somehow this was the only way to force the chart to refresh */
          this.refreshKey = !this.refreshKey;
        });
      } catch(err) {
        //Vue.set(this.loadingStatus, false);
        console.log(err);
      } finally {
        //console.log("finally");
      }
    },

    async viewUnscheduledFamilyRecalls(event, props) {
      event.preventDefault();
      //Vue.set(this.loadingStatus, true);
      var _this = this;
      try {
        const handle = this.$showPanel({
          component : HygieneOpportunities,
          openOn: 'right',
          width: 1850,
          disableBgClick: true,
          disableEscClick: true,
          props: {
              category: 'unscheduledFamilyRecalls'
          }
        });

        handle.promise.then(async(result) => {
          //console.log(`Got result: ${JSON.stringify(result, null, 4)}`);          
        });
      } catch(err) {
        //Vue.set(this.loadingStatus, false);
        console.log(err);
      } finally {
        //console.log("finally");
      }
    },

    async viewXrays(event, props) {
      event.preventDefault();
      //Vue.set(this.loadingStatus, true);
      var _this = this;
      try {
        const handle = this.$showPanel({
          component : HygieneOpportunities,
          openOn: 'right',
          width: 1850,
          disableBgClick: true,
          disableEscClick: true,
          props: {
              category: 'xrays'
          }
        });

        handle.promise.then(async(result) => {
          //console.log(`Got result: ${JSON.stringify(result, null, 4)}`);          
        });
      } catch(err) {
        //Vue.set(this.loadingStatus, false);
        console.log(err);
      } finally {
        //console.log("finally");
      }
    },

    async viewUnscheduledTx(event, props) {
      event.preventDefault();
      //Vue.set(this.loadingStatus, true);
      var _this = this;
      try {
        const handle = this.$showPanel({
          component : HygieneOpportunities,
          openOn: 'right',
          width: 1850,
          disableBgClick: true,
          disableEscClick: true,
          props: {
              category: 'unscheduledTx'
          }
        });

        handle.promise.then(async(result) => {
          //console.log(`Got result: ${JSON.stringify(result, null, 4)}`);          
        });
      } catch(err) {
        //Vue.set(this.loadingStatus, false);
        console.log(err);
      } finally {
        //console.log("finally");
      }
    },

    async viewOrthoBenefits(event, props) {
     event.preventDefault();
      //Vue.set(this.loadingStatus, true);
      var _this = this;
      try {
        const handle = this.$showPanel({
          component : HygieneOpportunities,
          openOn: 'right',
          width: 1850,
          disableBgClick: true,
          disableEscClick: true,
          props: {
              category: 'orthoBenefits'
          }
        });

        handle.promise.then(async(result) => {
          //console.log(`Got result: ${JSON.stringify(result, null, 4)}`);          
        });
      } catch(err) {
        //Vue.set(this.loadingStatus, false);
        console.log(err);
      } finally {
        //console.log("finally");
      }
    },

    /**
     * Handle New Patients click - show new report panel for all users
     * @param {Event} event - Click event
     * @param {String} timeframe - 'today' or 'month-to-date'
     */
    handleNewPatientsClick(event, timeframe) {
      event.preventDefault();
      
      // Show new report panel for all users
      this.viewNewPatientReport(event, timeframe);
    },

    /**
     * Open the New Patient Report slide-out panel
     * @param {Event} event - Click event
     * @param {String} timeframe - 'today' or 'month-to-date'
     */
    async viewNewPatientReport(event, timeframe) {
      event.preventDefault();
      var _this = this;
      try {
        const newPatientReportHandle = this.$showPanel({
          component: NewPatientReport,
          openOn: 'right',
          width: this.windowWidth * 0.95,
          cssClass: 'NewPatientReportPanelClass',
          disableBgClick: true,
          disableEscClick: true,
          props: {
            initialTimeframe: timeframe, // 'today' or 'month-to-date'
            huddleDate: this.$route.query.d || moment().format('YYYY-MM-DD')
          }
        });

        newPatientReportHandle.promise.then(async (result) => {
          // Handle panel close if needed
        });
      } catch (err) {
        console.log(err);
        this.$toast.error('Error opening New Patient Report');
      }
    }
  },

  computed: {

    ...mapGetters({
        'getProvNum' : 'customer/getProvNum'
    }), 

    chartStyles() {
      return {
        width: '100%',
        height: window.innerWidth < 1400 ? '220px' :  '200px',
        /* height: window.innerWidth < 1400 ? '270px' :  '150px',*/

      }
    },

    dataToDisplay() {
      if(this.results && this.results.data && this.results.data.length > 0)
          return this.results.data;
    },

    huddleGoals() {
      if(this.dataToDisplay && this.dataToDisplay[10] && this.dataToDisplay[10].length > 0 && this.dataToDisplay[10][0].Property === 'HUDDLE_GOALS') {
        return JSON.parse(this.dataToDisplay[10][0].PropertyValue);
      }
    },

    /**
     * Clinical hours appointments data from backend (index 13)
     * Returns all appointments (scheduled, completed, broken) for calculating clinical hours
     */
    clinicalHoursAppointmentsToday() {
      if (this.dataToDisplay && this.dataToDisplay[13]) {
        return this.dataToDisplay[13];
      }
      return [];
    },

    /**
     * Monthly production goal per provider from backend (result set index 14).
     * Rows: { ProvNum, MonthlyGoal } - insurance-adjusted value of ALL appointments
     * (AptStatus 1 or 2) for the FULL calendar month, so the goal is stable all month.
     * Guarded: an older backend returns only 14 result sets - bars silently hide.
     */
    monthlyProductionGoalByProvider() {
      if (this.dataToDisplay && Array.isArray(this.dataToDisplay[14])) {
        return this.dataToDisplay[14];
      }
      return [];
    },

    /**
     * Open Dental provider schedule for the huddle date (result set index 15).
     * Rows: { ProvNum, SchedDate ('YYYY-MM-DD'), StartTime, StopTime ('HH:MM:SS') } - used for clinical hours.
     * Guarded: an older backend returns only 15 result sets - clinical hours fall back to first appointment through the latest appointment end.
     */
    providerScheduleToday() {
      if (this.dataToDisplay && Array.isArray(this.dataToDisplay[15])) {
        return this.dataToDisplay[15];
      }
      return [];
    },

    /**
     * Monthly Scheduled Goal (right-panel bar): for every calendar day from the 1st
     * through the last day of the huddle month, sum all providers' per-weekday goal
     * for that day's weekday, then total. Fixed target - counts all providers'
     * HUDDLE_GOALS.providerGoals, ignoring who's actually on schedule. ProductionGoal
     * is keyed "1"=Mon.."6"=Sat (no Sunday); moment().format('d') gives 0=Sun..6=Sat.
     * Mirrors HuddleDetails.vue getWeeklyGoal, summed across the month.
     */
    monthlyScheduledGoal() {
      if (!this.huddleGoals || !this.huddleGoals.providerGoals) return 0;
      const d = this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD');
      const end = moment(d).endOf('month');
      let cur = moment(d).startOf('month');
      let total = 0;
      while (cur.isSameOrBefore(end, 'day')) {
        const dayNum = cur.format('d');
        for (const p of this.huddleGoals.providerGoals) {
          const g = p.ProductionGoal ? p.ProductionGoal[dayNum] : null;
          if (g !== undefined && g !== null && g !== '') total += Number(g) || 0;
        }
        cur.add(1, 'day');
      }
      return total;
    },

    /**
     * Total practice production per hour (completed production / total clinical hours)
     * Formula: Total Net Production ÷ SUM of all providers' clinical hours
     */
    totalPracticeProductionPerHour() {
      if (!this.providersOnScheduleToday || this.providersOnScheduleToday.length === 0) {
        return null;
      }

      let totalClinicalHours = 0;
      this.providersOnScheduleToday.forEach(provNum => {
        totalClinicalHours += this.getClinicalHoursToday(provNum);
      });

      if (totalClinicalHours <= 0) {
        return null;
      }

      return this.netProductionToday / totalClinicalHours;
    },

    /**
     * Total practice scheduled production per hour
     */
    totalPracticeScheduledProductionPerHour() {
      if (!this.providersOnScheduleToday || this.providersOnScheduleToday.length === 0) {
        return null;
      }

      let totalClinicalHours = 0;
      this.providersOnScheduleToday.forEach(provNum => {
        totalClinicalHours += this.getClinicalHoursToday(provNum);
      });

      if (totalClinicalHours <= 0) {
        return null;
      }

      return this.scheduledProductionToday / totalClinicalHours;
    },

    outStandingClaimsData() {
      if(this.dataToDisplay && this.dataToDisplay[11]) {
        return this.dataToDisplay[11];
      }
    },

    onSchedulepatientBalances() {
      if(this.dataToDisplay && this.dataToDisplay[12]) {
        return this.dataToDisplay[12];
      }
    },

    getOutstandingClaimsData() {
      if (this.outStandingClaimsData) {
        let a029 = this.outStandingClaimsData.filter(p => moment().diff(moment(p.DateSent), 'days') < 29);
        let a3059 = this.outStandingClaimsData.filter(p => moment().diff(moment(p.DateSent), 'days') >= 30 && moment().diff(moment(p.DateSent), 'days') <= 59);
        let a6089 = this.outStandingClaimsData.filter(p => moment().diff(moment(p.DateSent), 'days') >= 60 && moment().diff(moment(p.DateSent), 'days') <= 89);
        let a90plus = this.outStandingClaimsData.filter(p => moment().diff(moment(p.DateSent), 'days') >= 90);

        let a029total = _.sumBy(a029, 'InsuranceEstimate');
        let a3059total = _.sumBy(a3059, 'InsuranceEstimate');
        let a6089total = _.sumBy(a6089, 'InsuranceEstimate');
        let a90plustotal = _.sumBy(a90plus, 'InsuranceEstimate');

        return {
          hoverBackgroundColor: "red",
          hoverBorderWidth: 10,
          labels: [
            '0-29 Days',
            '30-59 Days',
            '60-89 Days',
            '90+ Days'
          ],
          datasets: [
            {
              label: "Outstanding Claims",
              backgroundColor: ['#86efac', '#93c5fd', '#fcd34d', '#f9a8d4'], // Soft: Light green, Light blue, Light amber, Light pink
              data: [a029total, a3059total, a6089total, a90plustotal]
            }
          ]
        }
      }
      return null;
    },
    
    // Transform data for the Net Production chart
    getMTDNetProductionChartData() {
      if (this.netProductionMTD && this.huddleGoals) {
        return {
          labels: ['Goal', 'Actual'], // X-axis labels
          datasets: [
            {
              label: 'Net Production', // Dataset label
              data: [this.huddleGoals.monthlyNetProduction, this.netProductionMTD], // Y-axis values
              backgroundColor: ['#64748b', '#3abf94'], // Goal (slate) vs Actual (green)
            },
          ],
        };
      }
      return null;
    },

    // Transform data for the Collections chart
    getMTDCollectionChartData() {
      if (this.collectionMTD && this.huddleGoals) {
        return {
          labels: ['Goal', 'Actual'], // X-axis labels
          datasets: [
            {
              label: 'Collections', // Dataset label
              data: [this.huddleGoals.monthlyCollection, this.collectionMTD], // Y-axis values
              backgroundColor: ['#64748b', '#14b8a6'], // Goal (slate) vs Actual (teal)
            },
          ],
        };
      }
      return null;
    },

    // Transform data for the New Patients chart
    getMTDNewPatientsChartData() {
      if (this.newPatientsMTD && this.huddleGoals) {
        return {
          labels: ['Goal', 'Actual'], // X-axis labels
          datasets: [
            {
              label: 'New Patients', // Dataset label
              data: [this.huddleGoals.monthlyNewPatients, this.newPatientsMTD.length], // Y-axis values
              backgroundColor: ['#93c5fd', '#3abf94'], // Soft light blue (Goal) vs Brand green (Actual)
            },
          ],
        };
      }
      return null;
    },

    /*
    getMTDNetProductionChartData() {
      this.refreshKey;
      if(this.netProductionMTD && this.huddleGoals) {
        return {
          data: [
            {
              bars: {
                fill: 1,
                lineWidth: 0,
                align: "center",
                order: 1,
                show: true,
                barWidth:2
              },
              data: [
                  [5,this.huddleGoals['monthlyNetProduction']]
                ]
            },
            {
              bars: {
                fill: 1,
                lineWidth: 0,
                align: "center",
                order: 2,
                show: true,
                barWidth:2
              },
              data: [
                  [10,this.netProductionMTD]
                ]
            },
          ],

          ticks: [
            [5,'Goal'],
            [10,'Actual'],
          ]
        }
      }
    },

    getMTDCollectionChartData() {
      this.refreshKey;
      if(this.collectionMTD && this.huddleGoals) {
        return {
          data: [
            {
              bars: {
                fill: 1,
                lineWidth: 0,
                align: "center",
                order: 1,
                show: true,
                barWidth:2
              },
              data: [
                  [5,this.huddleGoals.monthlyCollection]
                ]
            },
            {
              bars: {
                fill: 1,
                lineWidth: 0,
                align: "center",
                order: 2,
                show: true,
                barWidth:2
              },
              data: [
                  [10,this.collectionMTD]
                ]
            },
          ],
          ticks: [
            [5,'Goal'],
            [10,'Actual'],
          ]
        }
      }
    },

    getMTDNewPatientsChartData() {
      this.refreshKey;
      if(this.newPatientsMTD && this.huddleGoals) {
        return {
          data: [
            {
              bars: {
                fill: 1,
                lineWidth: 0,
                align: "center",
                order: 1,
                show: true,
                barWidth:2
              },
              data: [
                  [5,this.huddleGoals.monthlyNewPatients]
                ]
            },
            {
              bars: {
                fill: 1,
                lineWidth: 0,
                align: "center",
                order: 2,
                show: true,
                barWidth:2
              },
              data: [
                  [10,this.newPatientsMTD.length]
                ]
            },
          ],
          ticks: [
            [5,'Goal'],
            [10,'Actual'],
          ]
        }
      }
    },

    */

    providersWithScheduledProductionToday() {
      if(this.scheduledProductionTodayRaw)
        return _.groupBy(this.scheduledProductionTodayRaw, 'ProvNum');
    },

    providersWithGrossProductionToday() {
      if(this.grossProductionTodayRaw)
        return _.groupBy(this.grossProductionTodayRaw, 'ProvNum');
    },

    providersOnScheduleToday() {
      if(this.providersWithScheduledProductionToday && this.providersWithGrossProductionToday) {
        return [...new Set([...Object.keys(this.providersWithScheduledProductionToday), ...Object.keys(this.providersWithGrossProductionToday)])];
      }
    },

    grossProductionTodayRaw() {
      if(this.dataToDisplay) {
        let d = this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD');
        return this.dataToDisplay[0].filter(c => c.ProcDate === d);
      }
    },

    grossProductionToday() {
      if(this.grossProductionTodayRaw) {
        return this.grossProductionTodayRaw.reduce((a, b) => a + (b['GrossAppointmentValue'] || 0), 0);
      }
    },

    grossProductionTodayByProvider() {
      if(this.grossProductionTodayRaw) {
        //return _.groupBy(this.grossProductionTodayRaw, (n) => n.Provider);
        return _(this.grossProductionTodayRaw)
          .groupBy('ProvNum')
          .map((n, provider) => ({
            provider: provider, // technically this is wrong because provider is provnum at this point
            provNum: provider,
            grossProduction: _.sumBy(n, 'GrossAppointmentValue')
          }))
          .value();
      }
    },

    grossProductionMTD() {
      if(this.dataToDisplay) {
        return this.dataToDisplay[0].reduce((a, b) => a + (b['GrossAppointmentValue'] || 0), 0);
      }
    },

    grossProductionMTDByProvider() {
      if(this.dataToDisplay) {
        return _(this.dataToDisplay[0])
          .groupBy('ProvNum')
          .map((n, provider) => ({
            provider: provider, // this is provnum actually
            provNum: provider,
            grossProduction: _.sumBy(n, 'GrossAppointmentValue')
          }))
          .value();
      }
    },

    grossProductionTotalByProviderToday() {
      if(this.grossProductionTodayRaw) {
        let final = {};

        _(this.grossProductionTodayRaw)
        .groupBy("ProvNum")
        .map(function (n, provider) {
          let finalarray = [];
          let temp = _.groupBy(n, "ProcCode");                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
          //console.log(temp);
          _.forEach(temp, function (value, key) {
            //console.log(key);
            //console.log(value);
            let grossTotal = _.sumBy(value, "GrossAppointmentValue");
            //console.log(total);
            finalarray.push({
              ProcCode: key,
              Descript: value[0].Descript,
              GrossTotal: grossTotal,
              Count: value.length
            });
          });
          final[provider] = finalarray;
        })
        .value();
        return final;
      }
    },

    grossProductionTotalByProviderMTD() {
      if(this.dataToDisplay && this.dataToDisplay[0]) {
        let final = {};

        _(this.dataToDisplay[0])
        .groupBy("ProvNum")
        .map(function (n, provider) {
          let finalarray = [];
          let temp = _.groupBy(n, "ProcCode");
          //console.log(temp);
          let grossTotal;
          _.forEach(temp, function (value, key) {
            //console.log(key);
            //console.log(value);
            grossTotal = _.sumBy(value, "GrossAppointmentValue");
            //console.log(total);
            finalarray.push({
              ProcCode: key,
              Descript: value[0].Descript,
              GrossTotal: grossTotal,
              Count: value.length
            });
          });
          final[provider] = finalarray;
        })
        .value();
        return final;
      }
    },

    writeOffTodayRaw() {
      if(this.dataToDisplay) {
        let d = this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD');
        return this.dataToDisplay[1].filter(c => c.ProcDate === d);
        //return a.reduce((a, b) => a + (b['Writeoff'] || 0), 0);
      }
    },

    writeoffTotalByProviderToday() {
      if(this.writeOffTodayRaw) {
        let final = {};

        _(this.writeOffTodayRaw)
        .groupBy("ProvNum")
        .map(function (n, provider) {
          let finalarray = [];
          let temp = _.groupBy(n, "ProcCode");
          //console.log(temp);
          let writeoffTotal;
          _.forEach(temp, function (value, key) {
            //console.log(key);
            //console.log(value);
            writeoffTotal = _.sumBy(value, "Writeoff");
            //console.log(writeoffTotal);
            finalarray.push({
              ProcCode: key,
              //Descript: value[0].Descript,
              WriteoffTotal: writeoffTotal,
              Count: value.length
            });
          });
          final[provider] = finalarray;
        })
        .value();
        return final;
      }
    },

    writeoffTotalByProviderMTD() {
      if(this.dataToDisplay && this.dataToDisplay[1]) {
        let final = {};

        _(this.dataToDisplay[1])
        .groupBy("ProvNum")
        .map(function (n, provider) {
          let finalarray = [];
          let temp = _.groupBy(n, "ProcCode");
          //console.log(temp);
          _.forEach(temp, function (value, key) {
            //console.log(key);
            //console.log(value);
            let writeoffTotal = _.sumBy(value, "Writeoff");
            //console.log(total);
            finalarray.push({
              ProcCode: key,
              WriteoffTotal: writeoffTotal,
              Count: value.length
            });
          });
          final[provider] = finalarray;
        })
        .value();
        return final;
      }
    },

    writeOffToday() {
      if(this.writeOffTodayRaw) {
        return this.writeOffTodayRaw.reduce((a, b) => a + (b['Writeoff'] || 0), 0);
      }
    },

    writeOffTodayByProvider() {
      if(this.writeOffTodayRaw) {
        //return _.groupBy(this.writeOffTodayRaw, (n) => n.Provider);
        return _(this.writeOffTodayRaw)
          .groupBy('ProvNum')
          .map((n, provider) => ({
            provider: provider, // this actually has prov num
            provNum: provider,
            writeOff: _.sumBy(n, 'Writeoff')
          }))
          .value();
      }
    },

    writeOffMTD() {
      if(this.dataToDisplay) {
        return this.dataToDisplay[1].reduce((a, b) => a + (b['Writeoff'] || 0), 0);
      }
    },

    writeOffMTDByProvider() {
      if(this.dataToDisplay) {
        return _(this.dataToDisplay[1])
          .groupBy('ProvNum')
          .map((n, provider) => ({
            provider: provider, // this is provnum actually
            provNum: provider,
            writeOff: _.sumBy(n, 'Writeoff')
          }))
          .value();
      }
    },

    adjustmentsTodayRaw() {
      if(this.dataToDisplay) {
        let d = this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD');
        return this.dataToDisplay[2].filter(c => c.AdjDate === d);
        //return a.reduce((a, b) => a + (b['AdjAmt'] || 0), 0);
      }
    },

     adjustmentTotalByProviderToday() {
      if(this.adjustmentsTodayRaw) {
        let final = {};

        _(this.adjustmentsTodayRaw)
        .groupBy("ProvNum")
        .map(function (n, provider) {
          let finalarray = [];
          let temp = _.groupBy(n, "ProcCode");
          //console.log(temp);
          let adjustmentTotal;
          _.forEach(temp, function (value, key) {
            //console.log(key);
            //console.log(value);
            adjustmentTotal = _.sumBy(value, "AdjAmt");
            //console.log(writeoffTotal);
            finalarray.push({
              ProcCode: key,
              //Descript: value[0].Descript,
              AdjustmentTotal: adjustmentTotal,
              Count: value.length
            });
          });
          final[provider] = finalarray;
        })
        .value();
        return final;
      }
    },

    adjustmentTotalByProviderMTD() {
      if(this.dataToDisplay && this.dataToDisplay[2]) {
        let final = {};

        _(this.dataToDisplay[2])
        .groupBy("ProvNum")
        .map(function (n, provider) {
          let finalarray = [];
          let temp = _.groupBy(n, "ProcCode");
          //console.log(temp);
          _.forEach(temp, function (value, key) {
            //console.log(key);
            //console.log(value);
            let adjustmentTotal = _.sumBy(value, "AdjAmt");
            //console.log(total);
            finalarray.push({
              ProcCode: key,
              AdjustmentTotal: adjustmentTotal,
              Count: value.length
            });
          });
          final[provider] = finalarray;
        })
        .value();
        return final;
      }
    },

    adjustmentsToday() {
      if (this.adjustmentsTodayRaw) {
        return this.adjustmentsTodayRaw.reduce((a, b) => a + (b['AdjAmt'] || 0), 0);
      }
    },

    adjustmentsTodayByProvider() {
      if (this.adjustmentsTodayRaw) {
        //return _.groupBy(this.adjustmentsTodayRaw, (n) => n.Provider);
        return _(this.adjustmentsTodayRaw)
          .groupBy('ProvNum')
          .map((n, provider) => ({
            provider: provider,
            provNum: provider,
            adjAmt: _.sumBy(n, 'AdjAmt')
          }))
          .value();
      }
    },

    adjustmentsMTD() {
      if(this.dataToDisplay) {
        return this.dataToDisplay[2].reduce((a, b) => a + (b['AdjAmt'] || 0), 0);
      }
    },

    adjustmentsMTDByProvider() {
      if(this.dataToDisplay) {
        return _(this.dataToDisplay[2])
          .groupBy('ProvNum')
          .map((n, provider) => ({
            provider: provider,
            provNum: provider,
            adjustments: _.sumBy(n, 'AdjAmt')
          }))
          .value();
      }
    },

    netProductionToday() {
      return this.grossProductionToday - this.writeOffToday + this.adjustmentsToday;
    },

    netProductionMTD() {
      return this.grossProductionMTD - this.writeOffMTD + this.adjustmentsMTD;
    },

    scheduledProductionTodayRaw() {
      if(this.dataToDisplay) {
        let d = this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD');
        return this.dataToDisplay[8].filter(c => c.AptDate === d);
      }
    },

    scheduledProductionToday() {
      if(this.scheduledProductionTodayRaw && (this.netProductionToday || this.netProductionToday === 0)) {
        let npt = this.netProductionToday ? this.netProductionToday : 0;
        return npt + this.scheduledProductionTodayRaw.reduce((a, b) => a + (b['AdjustedValue'] || 0), 0);
      }
    },

    scheduledProductionTodayByProvider() {
      if(this.scheduledProductionTodayRaw) {
        return _(this.scheduledProductionTodayRaw)
          .groupBy('ProvNum')
          .map((n, provider) => ({
            provider: provider, // technically this is not provider. it's provnum
            provNum: provider,
            scheduledProduction: _.sumBy(n, 'AdjustedValue')
          }))
          .value();
      }
    },

    scheduledProductionMTD() {
      if(this.dataToDisplay && this.netProductionMTD || this.netProductionMTD === 0) {
        return this.netProductionMTD + this.dataToDisplay[8].reduce((a, b) => a + (b['AdjustedValue'] || 0), 0);
      }      
    },

    scheduledProductionMTDByProvider() {
      if(this.dataToDisplay) {
        return _(this.dataToDisplay[8])
          .groupBy('ProvNum')
          .map((n, provider) => ({
            provider: provider, // this is provnum actually
            provNum: provider,
            scheduledProduction: _.sumBy(n, 'AdjustedValue')
          }))
          .value();
      }
    },

    netTxPlannedMTDRaw() {
      if(this.dataToDisplay && this.dataToDisplay[9].length) {
        return this.dataToDisplay[9];
      }
    },

    netTxPlannedTodayRaw() {
      if(this.dataToDisplay) {
        let d = this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD');
        return this.dataToDisplay[9].filter(c => c.DateTP === d);
      }
    },

    netTxPlannedTodayByProvider() {
      if(this.netTxPlannedTodayRaw) {
        return _(this.netTxPlannedTodayRaw)
          .groupBy('ProvNum')
          .map((n, provider) => ({
            provider: provider,
            provNum: provider,
            netTxPlanned: _.sumBy(n, 'NetFee'),
            txAccepted: _.sumBy(n, function(o) { 
                          if(o.ProvNum === parseInt(provider,10) && (o.AptStatus === 1 || o.AptStatus === 2 ))
                            return o.NetFee;
                        })
          }))
          .value();
      }
    },

    netTxPlannedMTDByProvider() {
      if(this.netTxPlannedMTDRaw) {
        return _(this.netTxPlannedMTDRaw)
          .groupBy('ProvNum')
          .map((n, provider) => ({
            provider: provider,
            provNum: provider,
            netTxPlanned: _.sumBy(n, 'NetFee'),
            txAccepted: _.sumBy(n, function(o) { 
                          if(o.ProvNum === parseInt(provider,10) && (o.AptStatus === 1 || o.AptStatus === 2) )
                            return o.NetFee;
                        })
          }))
          .value();
      }
    },

    collectionToday() {
      if(this.dataToDisplay) {
        let d = this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD');
        let a = this.dataToDisplay[3].filter(c => c.PayDate === d);
        return a.reduce((a, b) => a + (b['PayAmt'] || 0), 0);
      }
    },

    /*

    this gets us collection by provider, want to avoid reading from paysplit table for now. we will see if we need to bring this back later in future.

    collectionTodayByProvider() {
      if(this.dataToDisplay) {
        let d = this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD');        
        let a = this.dataToDisplay[3].filter(c => c.PayDate === d);
        return _(a).groupBy('ProvNum').map((n, provider) => ({
          Provider: provider, // this actualy is provnum
          provNum: provider,
          PayAmt: _.sumBy(n, 'PayAmt')
        })).value();
      } else
        return [];
    },

    */

    /*

    collectionMTDByProvider() {
      if(this.dataToDisplay) {
        return _(this.dataToDisplay[3]).groupBy('ProvNum').map((n, provider) => ({
          Provider: provider,
          ProvNum: provider,
          PayAmt: _.sumBy(n, 'PayAmt')
        })).value();
      } else
        return [];
    },

    */

    collectionMTD() {
      if(this.dataToDisplay) {
        return this.dataToDisplay[3].reduce((a, b) => a + (b['PayAmt'] || 0), 0);
      }
    },

    newPatientsToday() {
      if(this.dataToDisplay) {
        let d = this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD');
        //let a = this.dataToDisplay[4].filter(c => c.FirstVisit === d);
        let a = this.dataToDisplay[4].filter(c => {
          // Convert timestamp to YYYY-MM-DD
          let visitDate = moment(c.FirstVisit).format('YYYY-MM-DD');
          return visitDate === d;
        });
        return a;
      }
    },

    newPatientsMTD() {
      if(this.dataToDisplay) {
        return this.dataToDisplay[4];
      }
    },

    hygieneSeenToday() {
      if(this.dataToDisplay) {
        let d = this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD');
        return this.dataToDisplay[5].filter(a => a.OriginalAppointment === d);
      } else
        return [];
    },

    hygieneReapptToday() {
      if(this.dataToDisplay) {
        let d = this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD');
        return this.dataToDisplay[5].filter(a => a.OriginalAppointment === d && a.RecallOrScalingScheduled !== null);
      } else
        return [];
    },

    hygieneReapptTodayPercent() {
      if(this.hygieneReapptToday && this.hygieneReapptToday.length > 0 && this.hygieneSeenToday && this.hygieneSeenToday.length > 0) {
        return ((this.hygieneReapptToday.length / this.hygieneSeenToday.length)*100).toFixed(0);
      } else
        return 0;
    },

    hygieneReapptMTD() {
      if(this.dataToDisplay) {
        return this.dataToDisplay[5].filter(a => a.RecallOrScalingScheduled !== null);
      } else
        return [];
    },

    hygieneReapptMTDPercent() {
      if(this.hygieneReapptMTD && this.hygieneReapptMTD.length > 0 && this.hygieneSeenMTD && this.hygieneSeenMTD.length > 0) {
        return ((this.hygieneReapptMTD.length / this.hygieneSeenMTD.length)*100).toFixed(0);
      } else
        return 0;
    },

    hygieneSeenMTD() {
      if(this.dataToDisplay) {
        return this.dataToDisplay[5];
      } else
        return [];
    },

    internalRefferalsRaw() {
      if(this.dataToDisplay) {
        return this.dataToDisplay[6];
      }
    },

    internalRefferals() {
      if(this.internalRefferalsRaw) {
        let b = _.groupBy(this.internalRefferalsRaw, 'ReferredFromPatNum');
        let c = _.map(b, function(items, patient) {
          return {
            ReferredFromPatientPatNum: patient,
            ReferredFromPatient: items[0].ReferredFrom,
            NetProduction: _.sumBy(items, 'NetProduction'),
            NumOfPatientsReferred: items.length,
            OpName: items[0].OpName
          }
        });
        return c;
      }
    },

    /*

     getProductionVsCollectionData() {
       if(this.scheduledProductionToday !== null && this.netProductionToday !== null && this.collectionToday !== null) {
        return { 
          data: [
            {        
              data:  [[5, this.scheduledProductionToday]] 
            },
            {        
              data: [[10, this.netProductionToday]]        
            }, 
            {        
              data:  [[15, this.collectionToday]]        
            }          
          ]          
        }
       }
    }, 
    */

    // Transform data for the Production vs Collection chart
    getProductionVsCollectionData() {
      if (this.scheduledProductionToday !== null && this.netProductionToday !== null && this.collectionToday !== null) {
        return {
          labels: ['On Schedule (Net)', 'Net Production', 'Collection'], // X-axis labels
          datasets: [
            {
              label: 'Production & Collection', // Dataset label
              data: [this.scheduledProductionToday, this.netProductionToday, this.collectionToday], // Y-axis values
              backgroundColor: ['#64748b', '#3abf94', '#3b82f6'], // Slate, primary green, blue
            },
          ],
        };
      }
      return null;
    },

    birthdaysOnScheduleData() {
      if(this.dataToDisplay) {
        return this.dataToDisplay[7];
      }
    }
  },

  watch: {
    allSettings(newValue, oldValue) {        
      //console.log(`watch changed. Old value: ${JSON.stringify(oldValue)}, \n New value: ${JSON.stringify(newValue)}`);
      if(!oldValue) {
        this.init();
      }        
    },

    windowWidth(newWidth, oldWidth) {
      //console.log(`window width changed from ${oldWidth} to ${newWidth}`);
    },

    huddleGoals(newValue, oldValue) {

    }
   }
};
</script>

<style lang='scss'>
.text-darkblue {
  color:#218bc3 !important;
}
.tab-content{
  background-color: #f9fbfd !important;
}
.nav-tabs{
  background-color: transparent !important;
}
.nav-tabs .nav-item {
  font-weight:bold;
}
.tab-content > .tab-pane {
  padding-top:2rem;
  padding-bottom:2rem;
  padding-right:2rem;
  padding-left: 0rem !important;
}

.chart-container {
  width: 100%; /* Ensure the container takes up the full width */
  min-height: 200px; /* Set a fixed height for the container */
  margin-bottom: 10px; /* Add spacing between charts */
  border-radius: 4px; /* Optional: Add rounded corners */
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-chart {
  text-align: center;
  color: #888; /* Gray text for the empty state */
  font-size: 16px;
  font-weight: bold;
}

</style>

<style lang="scss" scoped>
.huddle {
  overflow-x: hidden; /* Prevent horizontal scrollbar at the root level */
  width: 100%;
  padding: 0 15px; /* Add padding to prevent content from touching edges */
}

.chart-col {
  display: flex;
  flex-direction: column;
  padding: 10px; /* Consistent padding for spacing */
  min-width: 0; /* Prevent flex items from overflowing */
}

.chart-container {
  position: relative;
  width: 100%;
  height: 200px; /* Fixed height for consistency */
  overflow: hidden;
  min-height: 0;
  display: flex; /* Use flexbox to center the chart */
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically if needed */
  text-align: center; /* Ensure text (including legend) is centered */
}

.chart-legend { /* Target the legend if needed */
  text-align: center !important;
  margin: 0 auto; /* Center the legend horizontally */
}

.overdue-recall-card-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0; /* Prevent overflow in flex containers */
}

.empty-chart {
  text-align: center;
  color: #888;
  font-size: 16px;
  font-weight: bold;
  padding: 20px; /* Add padding for better visibility */
}

@media (max-width: 767px) {
  .chart-container {
    height: 150px; /* Reduce height on tablets */
  }
  .chart-legend {
    font-size: 10px; /* Optional: Reduce font size on smaller screens */
  }
}

@media (max-width: 576px) {
  .chart-container {
    height: 120px; /* Further reduce on mobile phones */
  }
  .chart-legend {
    font-size: 8px; /* Optional: Further reduce font size */
  }
}

/* Ensure the parent column and row don’t interfere with centering */
.b-col.chart-col {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.b-row {
  overflow-x: hidden;
  margin-left: -15px;
  margin-right: -15px;
}

/* "What do these numbers mean?" — a quieter sibling to the two primary header actions,
   so it reads as help rather than as another report to open. */
.explainer-btn {
  border-color: #cbd5e1;
  color: #475569;
  background: #ffffff;

  &:hover,
  &:focus {
    border-color: #3abf94;
    background: #f0fdf9;
    color: #0f172a;
  }

  i {
    margin-right: 4px;
  }
}

/* The info icons sit inline in table headers and captions - keep them from stretching a row. */
::v-deep .metric-info {
  line-height: 1;
}
</style>

<!-- Modern Dashboard Styles -->
<style src="./HuddleModern.scss" lang="scss" />
